/*
 * Define JQuery Extensions
 **********************************************************************/

$.fn.textWidth = function (text, font) {
	if (!$.fn.textWidth.fakeEl)
		$.fn.textWidth.fakeEl = $("<span>").hide().appendTo(document.body);
	$.fn.textWidth.fakeEl
		.html(text || this.val() || this.text())
		.css("font", font || this.css("font"));
	return $.fn.textWidth.fakeEl.width();
};

/**
 * Allow only hour input: XX:XX
 */
$.fn.myDatepicker = function (options) {
	// Max date example
	//$('#presentation_date').myDatepicker({maxDate: "+0d"});

	var defaults = {
		dateFormat: Hades.getDateMask(), //'dd-mm-yy',
		dayNames: Hades.weekDays(),
		dayNamesMin: Hades.locale().shortDays, //["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
		dayNamesShort: Hades.locale().shortDays, //["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
		monthNames: Hades.months(),
		monthNamesMin: Hades.locale().shortMonths, //["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
		monthNamesShort: Hades.locale().shortMonths, //["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
		changeYear: true,
		changeMonth: true,
		yearRange: "c-100:c+10",
		beforeShow: function (input) {
			$(input).css({
				position: "relative",
				"z-index": 9000,
			});
		},
	};

	$.extend(defaults, options);

	$(this).datepicker(defaults);
};

/**
 * Allow only hour input: XX:XX
 */
$.fn.allowHourOnly = function () {
	$(this).keydown(function (e) {
		var key = e.charCode || e.keyCode || 0;

		var newNumber = parseInt(String.fromCharCode(key));
		if (isNaN(newNumber)) {
			newNumber = null;
		}

		if (
			($(this).val().trim().length == 0 && newNumber > 2) ||
			($(this).val().trim().length == 3 && newNumber > 5) ||
			($(this).val().trim().length == 1 &&
				$(this).val().trim() == "2" &&
				newNumber > 3)
		) {
			return false;
		}

		if ($(this).val().length == 2 && !(key == 8 || key == 9 || key == 46)) {
			if (!(newNumber > 5)) {
				$(this).val($(this).val() + ":" + String.fromCharCode(key));
			}

			return false;
		} else if (
			$(this).val().length == 5 &&
			!(key == 8 || key == 9 || key == 46)
		) {
			return false;
		} else {
			return (
				key == 8 ||
				key == 9 ||
				key == 46 ||
				(key >= 37 && key <= 40) ||
				(key >= 48 && key <= 57) ||
				(key >= 96 && key <= 105)
			);
		}
	});

	$(this).keyup(function (e) {
		var key = e.charCode || e.keyCode || 0;

		if ($(this).val().length == 2 && !(key == 8 || key == 9 || key == 46)) {
			$(this).val($(this).val() + ":");
		}
	});
};

/*
 * jQuery Autocomplete extension
 **********************************************************************/

$.widget("khis.customAutocomplete", $.ui.autocomplete, {
	_renderMenu: function (ul, items) {
		var that = this,
			currentCategory = "";
		$.each(items, function (index, item) {
			if (item.category != currentCategory) {
				ul.append(
					"<li class='ui-autocomplete-group'>" + item.category + "</li>"
				);
				currentCategory = item.category;
			}
			that._renderItemData(ul, item);
		});
	},
	_renderItem: function (ul, item) {
		return $("<li>")
			.append(
				$(
					'<a><span style="font-weight: bold;">' +
						item.label +
						'</span><br /><span style="font-style: italic; font-size: 0.9em;">' +
						item.details +
						"</span>"
				)
			)
			.appendTo(ul);
	},
});

/*
 * Define global variable Hades
 **********************************************************************/
if (!Hades) {
	//debug.log('Create Hades.');

	var Hades = function () {};
}

(function ($) {
	if (Hades && Hades.isInitialized && Hades.isInitialized()) {
		//debug.log('Hades already initialized.');
		return;
	}

	/*
	 * Private variables
	 **********************************************************************/

	var _isInitialized = false,
		_isTouch = false,
		_noActionsTitle,
		_noActionsMsg,
		_noAccessTitle,
		_noAccessMsg,
		_genericErrorMsg,
		_workflowErrorMsg,
		_prevButtons,
		_appArea,
		_state,
		_layout,
		_resizeTimer,
		_currScreen,
		_currParams,
		_currArea,
		_clockIntervalId,
		_alertsIntervalId,
		_interactionsNotificationsIntervalId,
		_reimbursementRequestsNotificationsIntervalId,
		_dateMask,
		_hourMask,
		_dateHourMask,
		_fullDateMask,
		_leave_page_msg,
		_session_expired_msg,
		_add_msg,
		_edit_msg,
		_help_msg,
		_ok_msg,
		_cancel_msg,
		_select_options_msg,
		_select_option_msg,
		_no_results_msg,
		_mark_as_received_warning,
		_mark_as_executed_warning,
		_delegate_warning,
		_contextForGET = "",
		_max_upload_size,
		_upload_size_error_title,
		_upload_size_error,
		_upload_size_form_error,
		_help_save_msg,
		_https_enable,
		_host_url,
		_software_path,
		_contextualBarOrientation = "buttons_on_center",
		_notification_server,
		_notification_server_port,
		_notifyScreenOnExit = false,
		_locale = {},
		_goBackParams = {},
		_screenRef = [],
		_timeoutNow = 50000000,
		_timeoutTimer;

	var _date = new Date();
	var _days = ["", "", "", "", "", "", ""];
	var _months = ["", "", "", "", "", "", "", "", "", "", "", ""];
	var _monthsShort = ["", "", "", "", "", "", "", "", "", "", "", ""];
	var _userAreaId = 1;
	var _navigationStack = [];
	var _secondsCounter = 0;
	var _refreshTimeout = 300000;
	var _eventQueue = [];

	var _wfElem = null;
	var _wfElemData = null;
	var _wfStatus = {};
	var _cache = {};

	/*
	 * Private methods
	 **********************************************************************/

	/**
	 * Get global settings
	 */
	function getGlobalSettings() {
		$.getJSON("/hades/global_settings")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				_date = new Date(
					data.date.substr(0, 4),
					data.date.substr(4, 2) - 1,
					data.date.substr(6, 2),
					data.date.substr(8, 2),
					data.date.substr(10, 2)
				);

				_days = data.days;
				_months = data.months;
				_monthsShort = data.months_short;
				_dateMask = data.date_mask;
				_hourMask = data.hour_mask;
				_dateHourMask = data.date_hour_mask;
				_fullDateMask = data.full_date_mask;
				_genericErrorMsg = data.generic_error_msg;
				_workflowErrorMsg = data.workflow_error_msg;
				_noActionsTitle = data.no_actions_title;
				_noActionsMsg = data.no_actions_msg;
				_noAccessTitle = data.no_access_title;
				_noAccessMsg = data.no_access_msg;
				_leave_page_msg = data.leave_page_msg;
				_session_expired_msg = data.session_expired_msg;
				_add_msg = data.add_msg;
				_edit_msg = data.edit_msg;
				_help_msg = data.help_msg;
				_ok_msg = data.ok_msg;
				_cancel_msg = data.cancel_msg;
				_select_options_msg = data.select_options_msg;
				_select_option_msg = data.select_option_msg;
				_no_results_msg = data.no_results_msg;
				_mark_as_received_warning = data.mark_as_received_warning;
				_mark_as_executed_warning = data.mark_as_executed_warning;
				_delegate_warning = data.delegate_warning;
				_max_upload_size = data.max_upload_size;
				_upload_size_error_title = data.upload_size_error_title;
				_upload_size_error = data.upload_size_error;
				_upload_size_form_error = data.upload_size_form_error;
				_help_save_msg = data.help_save_msg;
				_https_enable = data.https_enable;
				_host_url = data.host_url;
				_software_path = data.software_path;
				_notification_server = data.notification_server;
				_notification_server_port = data.notification_server_port;

				_locale = {
					decimal: ".",
					thousands: ",",
					grouping: [3],
					currency: ["$", ""],
					dateTime: "%a %e %b %X %Y",
					date: "%d-%m-%Y",
					time: "%H:%M:%S",
					periods: [""],
					days: data.days,
					shortDays: data.days_short,
					months: data.months,
					shortMonths: data.months_short,
				};

				try {
					_refreshTimeout = parseInt(data.refresh_timeout);
				} catch (ex) {
					_refreshTimeout = 300;
				}

				// Update grid translations
				$.extend($.jgrid, {
					defaults: {
						recordtext: data.grid_record_text, //"Ver {0} - {1} de {2}",
						emptyrecords: data.grid_empty_records, //"Sem registos.",
						loadtext: data.grid_loading_text, //"A carregar...",
						pgtext: data.grid_pager_mask, //"Pág {0} de {1}"
					},
				});

				startClock();

				startProfAlerts();

				//startTimeoutTimer();
				//resetTimersHandler();

				if (_notification_server && _notification_server.length > 0) {
					startNotificationServer(
						_notification_server,
						_notification_server_port
					);
				}
			})
			.fail(function (xhr, status, error) {
				debug.log("ERROR: /hades/global_settings", error);
			});
	}

	function startTimeoutTimer() {
		_timeoutTimer = setTimeout(timeoutLock, _timeoutNow);
	}

	function timeoutLock() {
		$.get("/hades/lock_screen", null, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$.fancybox({
					content: data,
					padding: 0,
					margin: 0,
					width: 400,
					height: 400,
					autoSize: false,
					autoScale: true,
					autoDimensions: true,
					closeBtn: false,
					helpers: {
						overlay: {
							speedIn: 0,
							speedOut: 300,
							opacity: 0.7,
							css: {
								cursor: "pointer",
							},
							closeClick: false,
						},
						title: {
							type: "float", // 'float', 'inside', 'outside' or 'over'
						},
					},
					overlayColor: "#00A0AF",
					beforeShow: function () {
						$("div.lock_screen").addClass("blur");
						$("div.fancybox-inner").addClass("fancybox-skin-lock-screen");
					},
					afterClose: function () {
						$("div.lock_screen").removeClass("blur");
					},
				});

				$("#lock-screen-modal-ct").bind("unlockScreen", resetTimers);

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
				exam._callback(false, exam._action, exam._row);
			});
		//debug.log('TIMEOUT LOCK');
		//resetTimers()
	}

	function resetTimersHandler() {
		document.onmousemove = resetTimers;
		document.onclick = resetTimers;
		document.onmousewheel = resetTimers;
		document.onkeypress = resetTimers;
	}
	function resetTimers(event) {
		clearTimeout(_timeoutTimer);
		startTimeoutTimer();
	}

	function startNotificationServer(
		notification_server,
		notification_server_port
	) {
		var notificationServerUrl = notification_server;
		notificationServerUrl += ":" + notification_server_port + "/websocket";

		try {
			//debug.log('Start notification client on: ' + notificationServerUrl);
			Hades._serverNotificationDispatcher = new WebSocketRails(
				notificationServerUrl
			);

			//debug.log('_serverNotificationDispatcher', Hades._serverNotificationDispatcher);

			Hades._serverNotificationDispatcher.on_open = function (data) {
				//debug.log('Connection has been established: ', data);
				// You can trigger new server events inside this callback if you wish.
			};

			Hades._notificationChannel =
				Hades._serverNotificationDispatcher.subscribe(
					"general_notification",
					function (r) {
						debug.log("subscribe: success", r);
					},
					function (r) {
						debug.log("subscribe: error", r);
					}
				);

			// bind to a channel event
			Hades._notificationChannel.bind("info", function (data) {
				//debug.log('channel "info" event received', data);
				//  event_name, message, action, extra_data

				if (data.action == "notify") {
					$.notify(data.message);
				} else if (data.action == "modal") {
					Hades.showError("Notification", data.message, null, null);
				} else if (data.action == "go_to") {
					Hades.loadShortcut(data.extra_data.sh_id, data.extra_data);
					$.notify(data.message);
				} else if (data.action == "debug") {
					debug.log('channel "info" event received', data);
				} else if (data.action == "scare") {
					$.fancybox.open(
						[
							{
								type: "iframe",
								href: data.extra_data.url,
								title: "Eu sei o que fizeste o verão passado!",
							},
						],
						{
							padding: 0,
						}
					);
				}
			});
		} catch (ex) {
			debug.log(
				"Could not start notification client on: " + notificationServerUrl,
				ex
			);
		}
	}

	/**
	 * Start clock
	 */
	function startClock() {
		clearInterval(_clockIntervalId);
		_clockIntervalId = setInterval("Hades.updateClock()", 1000);
	}

	/**
	 * Start prof alerts
	 */
	function startProfAlerts() {
		clearInterval(_alertsIntervalId);
		_alertsIntervalId = setInterval("Hades.getUserAlerts()", 300000);

		Hades.getUserAlerts();
	}

	/**
	 * Start prof alerts
	 */
	function startProfNotifications(notificationType) {
		switch (notificationType) {
			case "interactions":
				clearInterval(_interactionsNotificationsIntervalId);
				_interactionsNotificationsIntervalId = setInterval(
					"Hades.getUserInteractionsNotifications()",
					60000
				); //1 min
				Hades.getUserInteractionsNotifications();
				break;
			case "reimbursement_requests":
				clearInterval(_reimbursementRequestsNotificationsIntervalId);
				_reimbursementRequestsNotificationsIntervalId = setInterval(
					"Hades.getUserReimbursementRequestsNotifications()",
					60000
				); //1 min
				Hades.getUserReimbursementRequestsNotifications();
				break;
			default:
				return null;
		}
	}

	/**
	 * Get user information : photo, name, age ...
	 */
	function getUserHeader() {
		$.get("/hades/user_header", null, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$("#user-info").html(data).hide().fadeIn();
			})
			.fail(function (xhr, status, error) {});
	}

	/**
	 * Get contextual information
	 *
	 * @param params
	 * @param areaId
	 * @param buttonId
	 * @param subButtonId
	 */
	function getContextualHeader(
		params,
		areaId,
		buttonId,
		subButtonId,
		sameButtons,
		screenName,
		reloadScreen,
		callback
	) {
		if (areaId == null || areaId === undefined) {
			areaId = _appArea;
		}

		// Add area_id to params
		if (params == null) {
			params = {};
		}

		params["area_id"] = areaId;

		$.get("/hades/contextual_header", params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (sameButtons == true) {
					if ($("#app-contextual-info").is(":visible")) {
						// Update contextual header
						$("#app-contextual-info").html(data);
						// Restore buttons
						$("#contextual-nav-inner").remove();
						$("#contextual-nav").append($(_prevButtons));
						$("#contextual-nav-buttons").attr("data-status", "loaded");
					} else {
						$("#app-contextual-info").empty();
					}

					if (callback) {
						callback();
					}
					// Reload screen
					else if (reloadScreen == true) {
						Hades.reloadScreen();
					} else {
						Hades.hideLoading();
					}
				} else {
					$("#app-contextual-info").html(data);

					if ($("#app-contextual-info-content").length > 0) {
						$("#contextual-nav-scroll-left").css("left", "200px");
					} else {
						$("#contextual-nav-scroll-left").css("left", "0px");
					}

					// Load top nav
					loadTopNav(areaId, buttonId, subButtonId, params, screenName);
				}

				// serialize context to append in ajax requests
				//serializeContext();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	function clearContextualInfo(callback) {
		_prevButtons = $("#contextual-nav-inner").clone();

		$("#app-contextual-info").empty();

		$.get("/hades/clear_contextual_header", null, null, "json")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (callback) {
					callback();
				}
				// serialize context to append in ajax requests
				//serializeContext();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	function serializeContext() {
		var cField,
			fields = $("#app-contextual-info input[type=hidden].serializable");

		_contextForGET = "";

		for (var i = 0; i < fields.length; i++) {
			cField = fields[i];
			if (i > 0) {
				_contextForGET += "&";
			}
			_contextForGET +=
				$(cField).attr("id").replace(/-/g, "_") + "=" + $(cField).val();
		}
	}

	/**
	 * Change application state
	 *
	 * @param state
	 */
	function changeAppState(state) {
		if (state === undefined) {
			state = _state;
		}

		var stateChanged = false,
			layout;

		switch (parseInt(state)) {
			case Hades.STATE_FULL_SCREEN():
				//$('#app-content-side-nav').hide();
				//$('#app-contextual-info').hide();

				layout = "layout_full_screen";
				_state = state;
				stateChanged = true;
				break;

			case Hades.STATE_SCREEN_W_TOP_NAV():
				//$('#app-content-side-nav').hide();
				//$('#app-contextual-info').show();
				layout = "layout_screen_w_top_nav";
				_state = state;
				stateChanged = true;
				break;

			case Hades.STATE_SCREEN_W_NAV():
				//$('#app-contextual-info').show();
				//$('#app-content-side-nav').show();
				layout = "layout_screen_w_nav";
				_state = state;
				stateChanged = true;
				break;

			case Hades.STATE_SCREEN_W_SIDENAV():
				//$('#app-contextual-info').hide();
				//$('#app-content-side-nav').show();
				layout = "layout_screen_w_side_nav";
				_state = state;
				stateChanged = true;
				break;

			default:
				break;
		}

		if (stateChanged) {
			$("body").removeClass(_layout);
			$("body").addClass(layout);

			_layout = layout;
			updateContentSize();
		}
	}

	/**
	 * Draw user navigation buttons
	 *
	 * @param buttons
	 */
	function drawUserNav(buttons) {
		var buttonsLen = buttons.length;
		var selectedBtn = undefined;

		if (!buttonsLen > 0) {
			return;
		}

		// Find default button
		for (var i = 0; i < buttonsLen; i++) {
			if (buttons[i].isDefault == true) {
				selectedBtn = buttons[i];

				break;
			}
		}

		// Selected first button if no default was found
		if (selectedBtn == undefined && buttonsLen > 0) {
			selectedBtn = buttons[0];
		}

		// Draw buttons
		$("#app-user-nav-buttons").empty();

		for (var i = 0; i < buttonsLen; i++) {
			if (buttons[i].render_template == "notification") {
				$.tmpl("appUserNavNotificationButtonTpl", buttons[i])
					.appendTo("#app-user-nav-buttons")
					.hide()
					.fadeIn();
				startProfNotifications(buttons[i].notification_type);
			} else {
				$.tmpl("appUserNavButtonTpl", buttons[i])
					.appendTo("#app-user-nav-buttons")
					.hide()
					.fadeIn();
			}
		}

		$("#app-user-nav-buttons").width(buttons.length * 70 + "px");
		$("#app-user-nav-buttons").data("mwidth", buttons.length * 70);

		// Mark button as selecteds
		$("#user_nav_" + selectedBtn.button_id).addClass("active");

		// Check if this button has a screen defined, if not load sub-buttons
		if (selectedBtn.screen != null && selectedBtn.screen.length > 0) {
			changeAppState(Hades.STATE_FULL_SCREEN());

			Hades.clearShadowComponents();
			loadScreen(selectedBtn.screen, null, selectedBtn.app_state);
		}
		// Check if this button has a shortcut
		else if (selectedBtn.shortcut_id) {
			$("#user_nav_" + selectedBtn.button_id).click();
		} else {
			changeAppState(selectedBtn.app_state);
			// Load sub-buttons
			Hades.getSubButtons(selectedBtn.area_id, selectedBtn.button_id);
		}
	}

	/**
	 * Draw side nav buttons
	 *
	 * @param subButtons
	 * @param subButtonId
	 */
	function drawSubButtons(data, subButtonId, level, screenName, params) {
		var buttons = data;

		$("#app-content-side-nav-buttons").hide().empty();

		var subButton,
			childList,
			screenToLoad,
			appStateForNewScreen,
			foundButton = false,
			children_html,
			child,
			childIsActive = false;
		var col, outerDiv, lblDiv, childrenDiv;
		var separatorDiv;
		var hidden = false;

		for (var i = 0; i < buttons.length; i++) {
			subButton = buttons[i].button;
			childList = buttons[i].sub_buttons;

			// Add separator
			if (subButton.break_after == i) {
				separatorDiv = $.tmpl("sideButtonsSeparatorTpl", [
					{ more: "Mais", less: "Menos", index: i },
				]);
				separatorDiv.appendTo("#app-content-side-nav-buttons");
				$(separatorDiv.find("div[data-action]")).click(Hades.showMoreMenus);
				hidden = true;
			}

			col = $('<div class="float_right"></div>');
			if (hidden) {
				col.addClass("hidden");
			}

			outerDiv = $(
				'<div class="" id="" data-screen="" data-state="" data-status="loaded">'
			);
			lblDiv = $(
				'<div class="" onmouseout="" onmouseover="" onclick="" title=""></div>'
			);
			childrenDiv = $(
				'<div class="side_nav_children" style="display: none;"></div>'
			);

			outerDiv.append(lblDiv);
			outerDiv.append(childrenDiv);
			col.append(outerDiv);

			outerDiv.attr("id", "subbutton_" + subButton.button_id);
			outerDiv.attr("data-id", subButton.button_id);
			outerDiv.attr("data-screen", subButton.screen);
			outerDiv.attr("data-state", subButton.app_state);
			outerDiv.attr("data-params", subButton.shortcut_params);

			lblDiv.attr("title", subButton.title);
			lblDiv.html(subButton.label);

			if (childList.length > 0) {
				outerDiv.addClass("side_nav_parent_btn");
				lblDiv.attr("onmouseout", "");
				lblDiv.attr("onmouseover", "");
				lblDiv.attr(
					"onclick",
					"Hades.getSideNavDeeperLevel(" + subButton.button_id + ");"
				);
				//lblDiv.addClass('side_children_nav_label opened');
				lblDiv.addClass("side_children_nav_label");

				children_html = $(
					'<table style="width: 100%;" cellpadding="0" cellspacing="0">'
				);

				for (var k = 0; k < childList.length; k++) {
					child = childList[k];
					childIsActive = false;

					if (subButtonId != null && subButtonId == child.button_id) {
						foundButton = true;
						childIsActive = true;

						if (screenName != null) {
							screenToLoad = screenName;
							appStateForNewScreen = child.appState;
						} else if (child.screen != null) {
							screenToLoad = child.screen;
							appStateForNewScreen = child.appState;
						}
					}

					children_html.append(
						'<tr><td align="right"><div class="side_nav_btn_ct" style="position: relative;"><div data-id="' +
							child.button_id +
							'" class="side_nav_btn ' +
							(childIsActive ? "active" : "") +
							'" id="subbutton_' +
							child.button_id +
							'" data-screen="' +
							child.screen +
							'" data-state="' +
							child.app_state +
							'" style="width: ' +
							(childIsActive ? "165" : "142") +
							'px;"><div class="side_nav_label" onmouseout="Hades.animateLeftMenu(this, 142);" onmouseover="Hades.animateLeftMenu(this, 165);" onclick="Hades.clickLeftMenu(this);" title="' +
							child.label +
							'">' +
							child.label +
							'</div></div><div class="ui-state-active" style="position: absolute; top:  7px; right: 7px; background: none; border: none;"><span style="display: none; cursor: pointer;" title="' +
							_add_msg +
							'" class="ui-icon ui-icon-plusthick default_add_button"></span><span style="display: none; cursor: pointer;" title="' +
							_edit_msg +
							'" class="ui-icon ui-icon-pencil default_edit_button"></span></div></div></td></tr>'
					);
				}

				children_html.appendTo(childrenDiv);
			} else {
				outerDiv.addClass("side_nav_btn");

				col
					.addClass("side_nav_btn_ct")
					.css("position", "relative")
					.append(
						'<div class="ui-state-active" style="position: absolute; top:  7px; right: 7px; background: none; border: none;"><span style="display: none; cursor: pointer;" title="' +
							_add_msg +
							'" class="ui-icon ui-icon-plusthick default_add_button"></span><span style="display: none; cursor: pointer;" title="' +
							_edit_msg +
							'" class="ui-icon ui-icon-pencil default_edit_button"></span></div>'
					);

				lblDiv.attr("onmouseout", "Hades.animateLeftMenu(this, 142);");
				lblDiv.attr("onmouseover", "Hades.animateLeftMenu(this, 165);");
				lblDiv.attr("onclick", "Hades.clickLeftMenu(this);");
				lblDiv.addClass("side_nav_label");
			}

			if (subButtonId != null && subButtonId == subButton.button_id) {
				foundButton = true;
				outerDiv.addClass("active");

				if (screenName != null) {
					screenToLoad = screenName;
					appStateForNewScreen = subButton.appState;
				} else if (subButton.screen != null) {
					screenToLoad = subButton.screen;
					appStateForNewScreen = subButton.appState;
				}
			}

			col.appendTo("#app-content-side-nav-buttons");
		}

		$("#app-content-side-nav-buttons").fadeIn();

		if (screenToLoad) {
			Hades.clearShadowComponents();
			loadScreen(screenToLoad, params, appStateForNewScreen);
		}

		if (!foundButton && buttons.length > 0) {
			var p = $("#app-content-side-nav-buttons div.side_nav_btn").first();

			if ($($(p).find(".side_nav_label"))) {
				$($(p).find(".side_nav_label")).click();
			} else {
				$($(p).find(".side_children_nav_label")).click();
			}
		}

		// Check if current sub button parent is open
		if (
			$(".side_nav_btn.active").closest(".side_nav_children").length > 0 &&
			!$(".side_nav_btn.active").closest(".side_nav_children").is(":visible")
		) {
			if (
				$(".side_nav_btn.active").closest(".side_nav_parent_btn").length > 0 &&
				$(".side_nav_btn.active")
					.closest(".side_nav_parent_btn")
					.find(".side_children_nav_label").length > 0
			) {
				$(".side_nav_btn.active")
					.closest(".side_nav_parent_btn")
					.find(".side_children_nav_label")
					.click();
			}
		}

		if (buttons.length == 0) {
			Hades.hideLoading();
		}
	}

	/**
	 * Load top nav
	 *
	 * @param buttonId
	 * @param subButtonId
	 */
	function loadTopNav(areaId, buttonId, subButtonId, params, screenName) {
		var requestParams = $.extend({ area_id: areaId }, params);

		$.getJSON("/hades/app_buttons", requestParams)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				var html = "",
					events = "",
					foundActive = false,
					l_areaId,
					l_buttonId,
					l_activeButtonHasScreen,
					l_screen;

				for (var i = 0; i < data.length; i++) {
					if (
						data[i].screen !== undefined &&
						data[i].screen != null &&
						data[i].screen != ""
					) {
						events =
							"onclick=\"Hades.clickTopMenu(this, true, '" +
							data[i].screen +
							"', " +
							data[i].app_state +
							', null, null);"';
					} else {
						events =
							"onclick=\"Hades.clickTopMenu(this, false, null, null, '" +
							data[i].area_id +
							"', " +
							data[i].button_id +
							');"';
					}

					html +=
						'<li data-id="' +
						data[i].button_id +
						'" id="top_nav_' +
						data[i].button_id +
						'" ' +
						events +
						"><span>" +
						data[i].label +
						"</span></li>";

					if (i == 0 && !foundActive) {
						l_areaId = data[i].area_id;
						l_buttonId = data[i].button_id;
						l_screen = data[i].screen;
					}

					if (
						buttonId != null &&
						parseInt(data[i].button_id) == parseInt(buttonId) &&
						!foundActive
					) {
						foundActive = true;
						l_areaId = data[i].area_id;
						l_buttonId = data[i].button_id;
						l_screen = data[i].screen;
					}
				}

				$("#contextual-nav-buttons")
					.data("status", "not_loaded")
					.css("top", 35)
					.css("width", "5000px")
					.html(html);

				// Load side nav for selected btn
				$("#top_nav_" + l_buttonId).addClass("active");

				// Load side nav
				if (l_screen && l_screen != "") {
					Hades.clearShadowComponents();
					loadScreen(l_screen, params, null, false);
				} else {
					loadSideNav(
						l_areaId,
						l_buttonId,
						subButtonId,
						params,
						null,
						screenName
					);
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	/**
	 * Load side nav buttons
	 *
	 * @param areaId
	 * @param parentId
	 * @param subButtonId
	 * @param params
	 */
	function loadSideNav(
		areaId,
		parentId,
		subButtonId,
		params,
		level,
		screenName
	) {
		Hades.showLoading();

		unloadScreen();

		$.getJSON("/hades/app_nav_tree", { area_id: areaId, parent_id: parentId })
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				drawSubButtons(data, subButtonId, level, screenName, params);

				//Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	/**
	 * Unload screen
	 */
	function unloadScreen() {
		// Destroy all context menus
		//$.contextMenu( 'destroy' );

		// Hide all popups
		Popups.hideAll();

		// Close modal windows
		$.fancybox.close(true);
		$("#dialog").remove();

		// Clear previous screen
		$("#screen-title").empty();
		$("#screen-content-holder").empty();

		if (_screenRef.length > 0) {
			$.each(_screenRef, function (a, b) {
				try {
					eval("delete " + b + ";");
				} catch (ex) {
					debug.log("ERROR: Delete screen reference: " + b, ex);
				}
			});

			_screenRef = [];
		}

		// Unload Viewer
		Hades.unloadViewer();
		Hades.hideViewer();

		Hades.clearContextualButtons();

		Hades.clearBalloonMessage();
	}

	/**
	 * Update content holder size
	 */
	function updateContentSize() {
		clearInterval(_resizeTimer);

		$("body").removeClass("touch").removeClass("no-touch");
		$("body").addClass(_isTouch ? "touch" : "no-touch");

		var cSize = Hades.contentSize();

		//$('#app-content-ct').css('height', cSize.height);
		//$('#screen-content-holder').css('width', cSize.width);
		//$('#screen-content-holder').css('max-height', cSize.height).css('height', cSize.height);
		//$('#app-content-side-nav').css('max-height', cSize.height).css('height', cSize.height);

		$("#app-contextual-info-additional-content-left").css(
			"width",
			cSize.width - 43
		);
		$("#app-contextual-info-additional-content-left").css(
			"min-width",
			cSize.width - 43
		);

		// Update viewer size and position
		$("#viewer-holder").css(
			"top",
			$("#screen-content-holder").position().top + "px"
		);
		$("#viewer-holder").height(cSize.height);
		$("#viewer-holder .viewer_content").css(
			"max-height",
			cSize.viewerCtnHeight
		);

		// Update resizable components
		var comps = $("[hades-resizable]"),
			comp,
			minH,
			hoffset,
			woffset,
			maxH,
			resizeType,
			w,
			h;

		for (var i = 0; i < comps.length; i++) {
			comp = $(comps[i]);
			resizeType = comp.attr("hades-resizable");
			minH = parseFloat(comp.attr("hades-minh"));
			hoffset = parseFloat(comp.attr("hades-hoffset"));
			woffset = parseFloat(comp.attr("hades-woffset"));

			if (comp.attr("hades-modal") == "true") {
				h = cSize.modalHeight;
				w = cSize.modalWidth;
			} else {
				h = cSize.height;
				w = cSize.width;
			}

			if (comp.attr("hades-type") == "grid") {
				// Horizontal resize
				if (resizeType == "horizontal" || resizeType == "both") {
					comp.setGridWidth(Math.max(w - woffset, cSize.minWidth - woffset));

					$.each(
						comp.find("table.sub_grid.ui-jqgrid-btable"),
						function (index, elem) {
							$(elem).setGridWidth(
								Math.max(w - woffset, cSize.minWidth - woffset) -
									45 /*magic number to adjust scroll*/
							);
						}
					);
				}

				// Vertical resize
				if (resizeType == "vertical" || resizeType == "both") {
					if (Hades.isTouch()) {
						if (
							$(comp.parents("div.ui-jqgrid-bdiv").children()[0]).height() > 0
						) {
							maxH = $(
								comp.parents("div.ui-jqgrid-bdiv").children()[0]
							).height();
						} else {
							maxH = Math.max(h - hoffset, minH);
						}
					} else {
						maxH = Math.max(h - hoffset, minH);
					}

					comp.setGridHeight(maxH);
				}
			} else if (comp.attr("hades-type") == "calendar") {
				maxH = h - hoffset;

				$("#" + $(comp).attr("id")).fullCalendar("option", "height", maxH);
			} else if (comp.attr("hades-type") == "timeline") {
				maxH = Math.max(h - hoffset, minH);

				comp.trigger("timelineResize", { h: maxH });
			} else {
				// Horizontal resize
				if (resizeType == "horizontal" || resizeType == "both") {
					w =
						comp.attr("hades-modal") == "true" ? cSize.modalWidth : cSize.width;
					comp.css("width", Math.max(w - woffset, cSize.minWidth));
				}

				// Vertical resize
				if (resizeType == "vertical" || resizeType == "both") {
					maxH = Math.max(h - hoffset, minH);
					comp.css("max-height", maxH);
				}

				// Vertical resize force size
				if (resizeType == "vertical_force") {
					if (comp.hasClass("pdf_viewer") || !Hades.isTouch()) {
						maxH = Math.max(h - hoffset, minH);
						comp.css("height", maxH);
					}
				}
			}
		}
	}

	/**
	 * Load application screen
	 *
	 * @param screen
	 * @param params
	 * @param state
	 *
	 */
	function loadScreen(screen, params, state, addToStack, forceChangeState) {
		Hades.clearKentraSidebarEventsListeners();

		var wf_status_id;

		if (forceChangeState && forceChangeState == true) {
			forceChangeState = true;
		} else {
			forceChangeState = false;
		}

		$.getJSON("/hades/get_wf_status", "", null)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				wf_status_id = data;
			})
			.fail(function (xhr, status, error) {
				return null;
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});

		if (screen === undefined || screen == null || screen == "/") {
			return false;
		}

		_secondsCounter = 0;
		_eventQueue = [];

		// Restore scroll
		// $('#screen-content-holder').css('overflow-y', 'auto');
		// $('html').css('overflow-y', 'auto');

		if (addToStack == null || addToStack === undefined) {
			addToStack = false;
		}

		state = parseFloat(state);

		Hades.showLoading();

		unloadScreen();

		for (var s in params) {
			if (params[s] && params[s].length > 0 && params[s][0] == "#") {
				params[s] = $(params[s]).val();
			}
		}

		var wf_status_id;

		$.get(screen, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				debug.log("forceChangeState", forceChangeState);

				if (state !== null && _state != state && forceChangeState) {
					changeAppState(state);
				}

				// Add previous screen to stack
				if (
					addToStack == true &&
					_currScreen != undefined &&
					_currScreen != null
				) {
					var _cacheElem = {};

					_cacheElem.appState = _state;
					_cacheElem.areaId = _currArea;
					_cacheElem.screen = _currScreen;
					_cacheElem.params = _currParams;

					if ($("#app-user-nav-buttons .active").attr("id")) {
						_cacheElem.topButtonId = $("#app-user-nav-buttons .active")
							.attr("id")
							.split("user_nav_")[1];
					} else {
						_cacheElem.topButtonId = null;
					}

					//_cacheElem.buttonId = $('#contextual-nav-buttons .active').attr('id').split('top_nav_')[1];
					//_cacheElem.subButtonId = $('#app-content-side-nav-buttons .active').attr('id').split('subbutton_')[1];

					_navigationStack.push(_cacheElem);

					//window.location = window.location.pathname.split('#')[0] + "#" + _navigationStack.length;
				}

				// Load new screen
				_currScreen = screen;
				_currParams = params;
				_currArea = _appArea;

				$("#screen-title").html(screen);

				const bodyTags = data.match(/<\/*body[^>]*>/gim);

				let body;

				if (bodyTags)
					body = data.slice(
						data.lastIndexOf(bodyTags[0]),
						data.lastIndexOf("</body>")
					);
				else body = data;

				$("#screen-content-holder")
					.empty()
					.append(body)
					.append('<div class="spacer" class="spacer"></div>')
					.hide()
					.fadeIn();

				updateContentSize();

				Hades.hideLoading();

				Hades.getScreenViewerSync();

				Hades.getUserAlerts();

				var appStateHash = _appArea;
				appStateHash +=
					"|" +
					($(".nav_button.active").length > 0
						? $(".nav_button.active").attr("id").split("user_nav_")[1]
						: "");
				appStateHash +=
					"|" +
					($("#contextual-nav-buttons .active").length > 0
						? $("#contextual-nav-buttons .active")
								.attr("id")
								.split("top_nav_")[1]
						: "");
				appStateHash +=
					"|" +
					($(".side_nav_btn.active").length > 0
						? $(".side_nav_btn.active").attr("id").split("subbutton_")[1]
						: "");
				appStateHash += "|" + _currScreen;
				appStateHash += "|" + _state;

				Hades.currentHash = appStateHash;
				Hades.availableHash[appStateHash] = true;

				var _contextParams = {
					id: $("#contextual-id").val(),
					type: $("#contextual-id-type").val(),
					area_id: $("#contextual-app-area-id").val(),
					wf_id: $("#contextual-wf-id").val(),
				};

				Hades.paramHistory[appStateHash] = $.extend(_contextParams, params);
				window.location.href = getScreenHash() + appStateHash;

				$("#app-content-ct").trigger("screenLoaded");

				$("#app-content-side-nav-buttons .default_add_button").hide();
				$("#app-content-side-nav-buttons .default_edit_button").hide();

				debug.log("wf_status_id", wf_status_id);
				if (parseInt(wf_status_id) == 3) {
					$(".default_add_button").not(".notrmv").remove();
					$(".default_edit_button").not(".notrmv").remove();
					$(".add_btn").not(".notrmv").remove();
					$(".edit_btn").not(".notrmv").remove();
				}
				if ($("#contextual-buttons-container .default_add_button").length > 0) {
					$("#app-content-side-nav-buttons .side_nav_btn.active")
						.parent()
						.find(".default_add_button")
						.show();
				} else if ($("#screen-content-holder .default_add_button").length > 0) {
					$("#app-content-side-nav-buttons .side_nav_btn.active")
						.parent()
						.find(".default_add_button")
						.show();
				}

				if (
					$("#contextual-buttons-container .default_edit_button").length > 0
				) {
					$("#app-content-side-nav-buttons .side_nav_btn.active")
						.parent()
						.find(".default_edit_button")
						.show();
				} else if (
					$("#screen-content-holder .default_edit_button").length > 0
				) {
					$("#app-content-side-nav-buttons .side_nav_btn.active")
						.parent()
						.find(".default_edit_button")
						.show();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});

		return true;
	}

	/**
	 * Load user navigation buttons
	 */
	function getUserNav() {
		$.getJSON("/hades/app_buttons", { area_id: _userAreaId })
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				drawUserNav(data);
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	function onWfActionClick(action) {
		workflow.executeAction(action, function (success, action) {
			if (success) {
				if (action.grid_id != null) {
					$("#" + action.grid_id).trigger("reloadGrid");
				} else {
					Hades.reloadScreen();
				}
			}

			Hades.hideLoading();
		});
	}

	function onPatientActionClick(action) {
		Hades.showLoading();
		debug.log("onPatientActionClick -action: ", action);

		var url;

		/*patient ticket simple*/
		if (action.data == "1") {
			url = "/patients/patient_ticket";
		} else if (action.data == "2") {
		/*patient ticket mishap_number*/
			url = "/patients/patient_ticket_mishap_number";
		} else if (action.data == "3") {

		/*patient ticket double*/
			url = "/patients/patient_ticket_double";
		} else if (action.data == "4") {

		/*patient ticket consults*/
			url = "/patients/patient_ticket_consult";
		} else if (action.data == "5") {

		/*patient ticket internment*/
			url = "/patients/patient_ticket_consult_internment";
		} else if (action.data == "6") {

		/* patient ticket consults :: task_id */
			url = "/patients/patient_ticket_consult?appointment_id=" + action.task_id;
		} else if (action.data == "7") {
			url = "/patients/mcdt_ticket";
		} else if (action.data == "8") {
			url = "/patients/patient_ticket_view";
		} else if (action.data == "9") {
			url = "/patients/process_mcdt_ticket";
		}

		debug.log("onPatientActionClick", url);

		window.params = {
			url: url,
		};

		$.getJSON("/printer/check_printer_configuration", null, null, "json")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);
				//debug.log('check_printer_configuration', data);
				if (data.printerName != null && data.printerName != "") {
					$.get("/printer/ticket_copies_modal", params, null, "html")
						.done(function (data, status, xhr) {
							Hades.checkIfUserIsAuthorized(data, status, xhr);
							$.fancybox({
								content: data,
								autoScale: true,
								autoDimensions: true,
								afterClose: Hades.getUserAlerts,
							});

							Hades.hideLoading();
						})
						.fail(function (xhr, status, error) {
							Hades.showError(error, xhr.responseText, xhr, status, error);
							Hades.hideLoading();
						});
				} else {
					Hades.showDocument(url);
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	}

	function onTopNavActionClick(action) {
		$("#" + action.data).click();
	}

	function getScreenHash() {
		var parts = window.location.href.split("/#/?hades="),
			_url = parts[0];

		if (_host_url) {
			return (
				(_https_enable ? "https://" + _host_url : "http://" + _host_url) +
				_software_path
			);
		}

		return _url + "/#/?hades=";
	}

	/*
	 * Public API
	 **********************************************************************/

	Hades.getDateMask = function () {
		return _dateMask;
	};

	Hades.getHourMask = function () {
		return _hourMask;
	};

	Hades.getDateHourMask = function () {
		return _dateHourMask;
	};

	Hades.getFullDateMask = function () {
		return _fullDateMask;
	};

	Hades.formatDate = function (day, month, year) {
		var format = Hades.getDateMask();

		day = parseInt(day) > 9 ? day : "0" + day;
		month = parseInt(month) > 8 ? month + 1 : "0" + (month + 1);

		format = format.replace("dd", day);
		format = format.replace("mm", month);
		format = format.replace("yy", year);

		return format;
	};

	Hades.formatDateFromJS = function (day, month, year) {
		var format = Hades.getDateMask();

		day = parseInt(day) > 9 ? day : "0" + day;
		month = parseInt(month) > 9 ? month : "0" + month;
		debug.log("fomat: ", format, day, month);
		format = format.replace("dd", day);
		format = format.replace("mm", month);
		format = format.replace("yy", year);

		return format;
	};

	Hades.printPdf = function () {
		Hades.hideLoading();

		var getMyFrame = document.getElementById("pdf-frame");
		if (getMyFrame) {
			Hades.printInterval = setInterval("Hades.openPrintPdfWindow()", 500);
		}
	};

	Hades.openPrintPdfWindow = function () {
		clearInterval(Hades.printInterval);

		var getMyFrame = document.getElementById("pdf-frame");
		if (getMyFrame) {
			getMyFrame.contentWindow.print();
		}
	};

	Hades.isInitialized = function () {
		return _isInitialized;
	};

	Hades.getCurrentContext = function () {
		return _contextForGET;
	};

	/**
	 * Update clock value
	 */
	Hades.updateClock = function () {
		_date.setSeconds(_date.getSeconds() + 1);

		var currentHours = _date.getHours();
		var currentMinutes = _date.getMinutes();
		var currentSeconds = _date.getSeconds();
		var currentYear = _date.getFullYear();

		// Pad the minutes and seconds with leading zeros, if required
		currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
		currentSeconds = (currentSeconds < 10 ? "0" : "") + currentSeconds;

		// Blink effect
		var sep = " ";
		if (currentSeconds % 2 == 0) {
			sep = ":";
		}

		// Compose the string for display
		var currentTimeString = currentHours + sep + currentMinutes;
		//var currentDateString = _days[_date.getDay()] + ", " + _date.getDate() + " de " + _months[_date.getMonth()] + ' de ' + currentYear;

		var currentDateString = Hades.getFullDateMask() || "";
		currentDateString = currentDateString.replace(
			"%week_day%",
			_days[_date.getDay()]
		);
		currentDateString = currentDateString.replace(
			"%month_day%",
			_date.getDate()
		);
		currentDateString = currentDateString.replace(
			"%month%",
			_months[_date.getMonth()]
		);
		currentDateString = currentDateString.replace("%year%", currentYear);

		// Update the time display
		$("#app-clock").attr("title", currentDateString);

		$("#app-clock-hour").html(currentTimeString);
		$("#app-clock-day").html(
			_date.getDate() + "&nbsp;" + _months[_date.getMonth()]
		);
		$("#app-clock-week-day").html(_days[_date.getDay()]);

		if ($("#app-clock").css("display") == "none") {
			$("#app-clock").fadeIn();
		}

		// Every minute refresh all elements with dates
		if (_date.getSeconds() == 0) {
			Hades.runTimeBasedEvents();
		}

		// Check events every minute
		_secondsCounter++;
		if (_secondsCounter > 0 && _secondsCounter % _refreshTimeout == 0) {
			var evt;
			for (var i = 0; i < _eventQueue.length; i++) {
				evt = _eventQueue[i];

				if (evt.fn) {
					//debug.log(evt.id);
					evt.fn();
				}
			}
		}
	};

	Hades.runTimeBasedEvents = function () {
		$(".refresh_date").each(function (i, item) {
			var props = GlobalFn.getCellProps($(item).attr("data-date"));
			var displayTime = new Date(Math.abs(props.timeDiff));
			var displayTimeStr;

			if (Math.abs(props.timeDiff) < 86400000 /* 24*3600*1000 */) {
				displayTimeStr =
					(displayTime.getUTCHours() < 10
						? "0" + displayTime.getUTCHours()
						: displayTime.getUTCHours()) +
					":" +
					(displayTime.getUTCMinutes() < 10
						? "0" + displayTime.getUTCMinutes()
						: displayTime.getUTCMinutes());
			} else {
				displayTimeStr =
					Math.floor(Math.abs(props.timeDiff) / 1000 / 3600 / 24) + " dia(s)";
			}

			var delay = $(item).attr("data-delay");
			displayTimeStr = delay != null ? delay : displayTimeStr;

			$(item).closest("[role=gridcell]").attr("title", displayTimeStr);
			$(item).html(displayTimeStr);

			//bgColor:bgColor
			//textColor
		});

		$(".refresh_bg_icon").each(function (i, item) {
			var props = GlobalFn.getCellProps($(item).attr("data-date")),
				_optimum = parseFloat($(item).data("opt")),
				_warning = parseFloat($(item).data("war")),
				_danger = parseFloat($(item).data("dan"));

			props.timeDiff = Math.abs(props.timeDiff);

			if (props.timeDiff >= _danger) {
				$(item).css("background-color", "#C86464");
			} else if (props.timeDiff >= _warning) {
				$(item).css("background-color", "#FAA732");
			} else if (props.timeDiff >= _optimum) {
				$(item).css("background-color", "rgb(0, 160, 175)");
			} else {
				$(item).css("background-color", "#829664");
			}
		});
	};

	Hades.getSecondsCounter = function () {
		return _secondsCounter;
	};

	Hades.resetSecondsCounter = function () {
		_secondsCounter = 0;
	};

	Hades.getEventQueue = function () {
		return _eventQueue;
	};

	Hades.addEventToQueue = function (id, evt) {
		var found = false;
		for (var i = 0; i < _eventQueue.length; i++) {
			evt = _eventQueue[i];

			if (evt.id == id) {
				found = true;
				_eventQueue[i] = evt;
				break;
			}
		}

		if (!found) {
			_eventQueue.push(evt);
		}

		return _eventQueue;
	};

	Hades.getUserAlerts = function () {
		$.getJSON("/hades/get_user_alerts").done(function (data, status, xhr) {
			if (data.success) {
				try {
					if (parseInt(data.counter) > 0) {
						$("#app-prof-alerts").html(data.text);
						$("#app-prof-alerts-ct").fadeIn();
					} else {
						$("#app-prof-alerts").html("");
						$("#app-prof-alerts-ct").hide();
					}
				} catch (ex) {}
			}
		});
	};

	Hades.getUserInteractionsNotifications = function () {
		$.getJSON("/hades/get_user_interactions_notifications").done(function (
			data,
			status,
			xhr
		) {
			if (data.success) {
				try {
					if (parseInt(data.counter) > 0) {
						var count_interactions;
						if (data.counter > 99) {
							count_interactions = "+99";
						} else {
							count_interactions = data.counter;
						}
						$("#user_nav_notification_interactions").html(count_interactions);
						$("#user_nav_notification_interactions").fadeIn();
					} else {
						$("#user_nav_notification_interactions").html("0");
						$("#user_nav_notification_interactions").hide();
					}
				} catch (ex) {}
			}
		});
	};

	Hades.getUserReimbursementRequestsNotifications = function () {
		$.getJSON("/hades/get_user_reimbursement_requests_notifications").done(
			function (data, status, xhr) {
				if (data.success) {
					try {
						if (parseInt(data.counter) > 0) {
							var count_reimbursement_requisitions;
							if (data.counter > 99) {
								count_reimbursement_requisitions = "+99";
							} else {
								count_reimbursement_requisitions = data.counter;
							}
							$("#user_nav_notification_reimbursement_requests").html(
								count_reimbursement_requisitions
							);
							$("#user_nav_notification_reimbursement_requests").fadeIn();
						} else {
							$("#user_nav_notification_reimbursement_requests").html("0");
							$("#user_nav_notification_reimbursement_requests").hide();
						}
					} catch (ex) {}
				}
			}
		);
	};

	Hades.currentHash = null;
	Hades.paramHistory = {};
	Hades.availableHash = {};

	Hades.showLanguagePopup = function () {
		Hades.showLoading();

		$.getJSON("/hades/get_languages", null, null, "json")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.length > 0) {
					Popups.Multichoice.show(
						$("#app-language-bar"),
						data,
						{ align: "right" },
						Hades.onLanguageChange
					);
				}

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.onLanguageChange = function (data) {
		Hades.showLoading();

		var params = {};
		params.lang_id = data.data;
		params.lang_desc = data.label;
		params.lang_abrv = data.label_abrv;
		params.lang_icon = data.icon;

		$.post("/hades/set_language", params, null, "json")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.success == true) {
					$(window).unbind("beforeunload", Hades.changePageProtection);

					window.location.reload();
				} else {
					Hades.hideLoading();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.STATE_FULL_SCREEN = function () {
		return 1;
	};

	Hades.STATE_SCREEN_W_TOP_NAV = function () {
		return 2;
	};

	Hades.STATE_SCREEN_W_NAV = function () {
		return 4;
	};

	Hades.STATE_SCREEN_W_SIDENAV = function () {
		return 5;
	};

	Hades.contentSize = function () {
		var h = $(window).height(),
			w = $(window).width();
		var cSize = {
			windowHeight: h,
			windowWidth: w,
			height: 0,
			width: 0,
			minWidth: 0,
			modalWidth: 0,
			modalHeight: 0,
			viewerCtnHeight: 0,
		};
		cSize.modalWidth = w - 100;
		cSize.modalHeight = h - 70;

		switch (parseInt(_state)) {
			case Hades.STATE_FULL_SCREEN():
				cSize.height = h - 30 - 70 - 40;
				cSize.width = w;
				cSize.minWidth = 960;
				cSize.viewerCtnHeight = h - 100 - 40 - 35 - 15 - 8 - 8;
				break;

			case Hades.STATE_SCREEN_W_TOP_NAV():
				cSize.height = h - 100 - 10 - 40 - 70;
				cSize.width = w;
				cSize.minWidth = 960;
				cSize.viewerCtnHeight = h - 100 - 10 - 40 - 70 - 35 - 15 - 8 - 8;
				break;

			case Hades.STATE_SCREEN_W_NAV():
				cSize.height = h - 100 - 10 - 40 - 70;
				cSize.width = w - 200;
				cSize.minWidth = 960 - 200;
				cSize.viewerCtnHeight = h - 100 - 10 - 40 - 70 - 35 - 15 - 8 - 8;
				break;

			case Hades.STATE_SCREEN_W_SIDENAV():
				cSize.height = h - 30 - 70 - 40;
				cSize.width = w - 200;
				cSize.minWidth = 960 - 200;
				cSize.viewerCtnHeight = h - 100 - 40 - 35 - 15 - 8 - 8;
				break;
		}

		if ($("#contextual-buttons-mirror").is(":visible")) {
			cSize.height = cSize.height - 40;
		}

		return cSize;
	};

	Hades.appArea = function () {
		return _appArea;
	};

	Hades.setApplicationState = function (state) {
		if (state !== undefined && typeof state === "number") {
			changeAppState(state);
			return state;
		}

		return false;
	};

	Hades.showMetroMenu = function (menu) {
		$("#overlay table.metro")
			.css("border-color", "transparent")
			.css("background-color", "transparent");

		// Show menu
		if (menu == "INSTITUTION") {
			$("#institutions-metro-menu").show();
			$("#software-metro-menu").hide();
		} else {
			$("#institutions-metro-menu").hide();
			$("#software-metro-menu").show();
		}

		$("#overlay").addClass("overlay_active").hide().fadeIn();
	};

	Hades.hideMetroMenu = function () {
		$("#overlay").removeClass("overlay_active").hide();

		$("#institutions-metro-menu").hide();
		$("#software-metro-menu").hide();
	};

	Hades.showViewer = function () {
		$("#kentra-side-bar").attr("is-sidebar-visible", true);
		$(window).trigger("resize");
		return this;
	};

	Hades.hideViewer = function () {
		$("#kentra-side-bar").attr("is-sidebar-visible", false);

		return this;
	};

	Hades.showLoading = function () {
		if ($("#lock-ui").is(":visible")) {
			return this;
		}

		$("#lock-ui-loading-ct").css("top", ($(window).height() - 150) / 2 + "px");
		$("#lock-ui-loading-ct").css("left", ($(window).width() - 150) / 2 + "px");
		$("#lock-ui").show();
		$("#lock-ui-bg").hide().fadeIn();

		return this;
	};

	Hades.hideLoading = function () {
		$("#lock-ui").hide();

		return this;
	};

	Hades.showError = function (title, data, xhr, status, error) {
		if (Hades.checkIfUserIsAuthorized(error, status, xhr)) {
			$.fancybox({ content: data, title: title, titlePosition: "float" });
		}

		return this;
	};

	Hades.clickTopMenu = function (
		menu,
		loadScreenButton,
		screen,
		app_state,
		area_id,
		button_id
	) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		$(menu).addClass("active").siblings().removeClass("active");

		if (loadScreenButton) {
			Hades.clearShadowComponents();
			loadScreen(screen, _goBackParams, app_state);
		} else {
			Hades.getSubButtons(area_id, button_id, _goBackParams);
		}

		_goBackParams = {};
	};

	Hades.showMoreMenus = function () {
		var elem = $(this);
		var childs, index, total;

		if ($(elem).data("action") == "more") {
			$("#app-content-side-nav-buttons div[data-action=more]").hide();
			$("#app-content-side-nav-buttons div[data-action=less]").show();

			index = $(elem).parent().data("index");
			childs = $("#app-content-side-nav-buttons").find("div.side_nav_btn_ct");
			total = childs.length;

			debug.log(index, total, childs);

			for (var i = index; i < total; i++) {
				$(childs[i]).removeClass("hidden");
			}
		} else if ($(elem).data("action") == "less") {
			$("#app-content-side-nav-buttons div[data-action=less]").hide();
			$("#app-content-side-nav-buttons div[data-action=more]").show();
			index = $(elem).parent().data("index");
			childs = $("#app-content-side-nav-buttons").find("div.side_nav_btn_ct");
			total = childs.length;

			debug.log(index, total, childs);

			for (var i = index; i < total; i++) {
				$(childs[i]).addClass("hidden");
			}
		}
	};

	Hades.animateLeftMenu = function (menu, amount, padding) {
		var m = $(menu).parent();

		if (m.hasClass("active")) {
			return;
		}

		m.animate(
			{
				width: amount,
			},
			"fast"
		);
	};

	Hades.clickLeftMenu = function (menu) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		var m = $(menu).parent();

		$("div.side_nav_btn").removeClass("active").css("width", "142px");

		m.addClass("active").css("width", "165px");

		var paramsArray,
			param,
			params = {};

		if (m.data("params")) {
			paramsArray = m.data("params").split(";");

			for (var i = 0; i < paramsArray.length; i++) {
				param = paramsArray[i];

				try {
					params[param.split(":")[0]] = param.split(":")[1];
				} catch (ex) {
					//debug.log('Invalid param.', ex);
				}
			}
		}

		params = $.extend(params, _goBackParams);
		_goBackParams = {};

		// Clear navigation stack
		_navigationStack = [];

		Hades.clearShadowComponents();
		Hades.loadScreen(m.attr("data-screen"), params, m.attr("data-state"), true);
	};

	Hades.getSubButtons = function (
		area,
		parentId,
		params,
		level,
		screenName,
		subButtonId
	) {
		loadSideNav(area, parentId, subButtonId, params, level, screenName);
	};

	Hades.loadArea = function (
		areaId,
		buttonId,
		subButtonId,
		params,
		screenName
	) {
		if (areaId === undefined || areaId == null) {
			Hades.showError("", _genericErrorMsg);
			Hades.hideLoading();
			return false;
		}

		Hades.showLoading();

		_appArea = parseInt(areaId);

		// Clear screen
		unloadScreen();
		// Clear navigation stack
		_navigationStack = [];
		// Clear side nav
		$("#app-content-side-nav-buttons").empty();

		switch (_appArea) {
			// User area
			case 1:
				// Clear previous area
				clearContextualInfo(function () {
					if (_state == 5) {
						// Load sub-buttons
						Hades.getSubButtons(
							areaId,
							$(".nav_button.active").attr("id").split("user_nav_")[1],
							params,
							null,
							screenName,
							subButtonId
						);
					} else if (screenName) {
						// Select button
						$("#user_nav_" + buttonId)
							.addClass("active")
							.siblings()
							.removeClass("active");

						Hades.clearShadowComponents();
						loadScreen(screenName, params, Hades.STATE_FULL_SCREEN());
					} else {
						// Default area(UserNav), select button
						$("#user_nav_" + buttonId).trigger("click");
					}
				});

				break;

			// Area with custom nav
			default:
				_prevButtons = $("#contextual-nav-inner").clone();

				getContextualHeader(
					params,
					areaId,
					buttonId,
					subButtonId,
					false,
					screenName
				);
				break;
		}
	};

	Hades.reloadContextualHeader = function (reloadScreen) {
		if (parseInt(_appArea) == 1) {
			return;
		}

		var params = {};
		params.id = $("#contextual-id").val();
		params.type = $("#contextual-id-type").val();
		params.area_id = $("#contextual-app-area-id").val();
		params.wf_id = $("#contextual-wf-id").val();
		params.financial_institution_id = $(
			"#contextual-financial-institution-id"
		).val();
		params.branch_id = $("#contextual-branch-id").val();

		_prevButtons = $("#contextual-nav-inner").clone();

		getContextualHeader(params, null, null, null, true, null, reloadScreen);
	};

	Hades.updateContextualHeader = function (params) {
		_prevButtons = $("#contextual-nav-inner").clone();

		getContextualHeader(params, null, null, null, true);
	};

	Hades.loadPartial = function (
		partialUrl,
		params,
		containerId,
		callback,
		useLoading
	) {
		var _loading = true;

		if (useLoading === false) {
			_loading = false;
		}

		if (_loading) {
			Hades.showLoading();
		}

		$.get(partialUrl, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$("#" + containerId)
					.html(data)
					.hide()
					.fadeIn();
				$(window).trigger("resize");

				if (_loading) {
					Hades.hideLoading();

					if (
						typeof calendar_availability &&
						containerId === "calendar-outer"
					) {
						$("#" + containerId).show();
					}
				}

				if (callback) {
					callback();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.loadScreen = function (
		screen,
		params,
		appState,
		resetStack,
		forceChangeState
	) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		debug.log("LoadScreen");

		debug.log("params", params);

		_notifyScreenOnExit = false;

		Hades.clearBalloonMessage();

		// Clear fileDownload Cookie
		document.cookie =
			"fileDownload=; expires=" + new Date(1000).toUTCString() + "; path=/";

		if (resetStack == null || resetStack === undefined) {
			resetStack = false;
		}

		if (resetStack) {
			// Clear navigation stack
			_navigationStack = [];
		}

		debug.log("forceChangeState1", forceChangeState);

		Hades.clearShadowComponents();
		loadScreen(screen, params, appState, !resetStack, forceChangeState);
	};

	Hades.reloadScreen = function (params) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		var _params = $.extend(_currParams, params);
		Hades.clearShadowComponents();
		loadScreen(_currScreen, _params, _state, false);

		_goBackParams = {};
	};

	Hades.setCurrentScreenParams = function (params) {
		_currParams = params;
	};

	Hades.getCurrentScreenParams = function () {
		if (_currParams) {
			return _currParams;
		} else {
			return {};
		}
	};

	Hades.loadModal = function (screen, params, containerId, width, height) {
		if (width === undefined || width == null) {
			width = 600;
		}

		if (height === undefined || height == null) {
			height = "auto";
		}

		$.get(screen, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$(data).appendTo("body");
				$("#" + containerId).dialog({
					height: height,
					width: width,
					modal: true,
					resizable: false,
					dialogClass: "modal_screen",
					close: function () {
						$("#" + containerId).dialog("destroy");
						$("#" + containerId).remove();
					},
				});

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.loadShortcut = function (id, params) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		if (id == null || id == "") {
			return false;
		}

		Hades.showLoading();

		var requestParams = $.extend({ sh_id: id }, params);
		// Load episode info
		$.getJSON("/hades/shortcut_info", requestParams)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data == null || data.length == 0) {
					Hades.showError(Hades.noAccessTitle(), Hades.noAccessMsg());
					Hades.hideLoading();
					return;
				}

				//IF POST VALIDATION
				/*
                    if(validate){
                        Hades.validate()
                       else
                        xxxx();


                 */

				var sh_params = {};

				if (data.params && data.params.length > 0) {
					var _p = data.params.split(";"),
						_pp,
						_k,
						_v;
					for (var i = 0; i < _p.length; i++) {
						if (_p.length > 0) {
							_pp = _p[i].split(":");

							if (_pp.length > 0) {
								_k = _pp[0];
								_v = _pp[1];

								sh_params[_k] = _v;
							}
						}
					}
				}

				params = $.extend(sh_params, params);

				debug.log("Hades load shortcut:", params);

				if (data.area_id == 1 || data.area_id != _appArea) {
					// Clear previous area
					clearContextualInfo(function () {
						changeAppState(data.app_state);

						// Unselect all top buttons
						$(".nav_button").removeClass("active");
						// Select top button id
						if ($("#user_nav_" + data.top_button_id).length > 0) {
							$("#user_nav_" + data.top_button_id)
								.addClass("active")
								.siblings()
								.removeClass("active");
						}

						Hades.loadArea(
							data.area_id,
							data.button_id,
							data.sub_button_id,
							params,
							data.screen
						);
					});
				} else {
					clearContextualInfo(function () {
						getContextualHeader(
							params,
							data.area_id,
							data.button_id,
							data.sub_button_id,
							true,
							data.screen,
							null,
							function () {
								if (data.app_state == Hades.STATE_SCREEN_W_TOP_NAV()) {
									if (data.button_id) {
										$(
											"#contextual-nav-buttons li[data-id=" +
												data.button_id +
												"]"
										).click();
									} else {
										$("#contextual-nav-buttons li").first().click();
									}
								} else if (data.app_state == Hades.STATE_SCREEN_W_SIDENAV()) {
									if (data.sub_button_id) {
										$(
											"#app-content-side-nav-buttons .side_nav_btn[data-id=" +
												data.sub_button_id +
												"] .side_nav_label"
										).click();
									} else {
										$("#app-content-side-nav-buttons .side_nav_btn")
											.first()
											.find(".side_nav_label")
											.click();
									}
								} else {
									if (data.button_id) {
										var currButton = $(
											"#app-content-side-nav-buttons .side_nav_btn.active"
										).data("id");

										if (data.button_id != currButton) {
											$(
												"#contextual-nav-buttons li[data-id=" +
													data.button_id +
													"]"
											)
												.addClass("active")
												.siblings()
												.removeClass("active");

											// Load side nav
											loadSideNav(
												data.area_id,
												data.button_id,
												data.sub_button_id,
												params,
												null,
												data.screen
											);
										} else {
											if (data.sub_button_id) {
												$(
													"#app-content-side-nav-buttons .side_nav_btn[data-id=" +
														data.sub_button_id +
														"] .side_nav_label"
												).click();
											} else {
												$("#app-content-side-nav-buttons .side_nav_btn")
													.first()
													.find(".side_nav_label")
													.click();
											}
										}
									} else {
										$("#contextual-nav-buttons li").first().click();
									}
								}
							}
						);
					});
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades._original_onmousewheel = window.onmousewheel;

	Hades.init = function () {
		const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
		$.ajaxSetup({
			headers: {
				"X-CSRF-Token": csrfToken,
			},
		});

		// Check for touch screen
		//_isTouch = ("ontouchstart" in document.documentElement);
		_isTouch =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			) && "ontouchstart" in document.documentElement;

		$("body").removeClass("touch").removeClass("no-touch");
		$("body").addClass(_isTouch ? "touch" : "no-touch");

		if (_isInitialized) {
			//debug.log('init(): Hades already initialized.');
			return false;
		}

		_isInitialized = true;

		/*
        $.ajaxSettings.beforeSend = function(jqXHR,setting){
            try {
                if(setting.type === 'GET'){
                    if(setting.url.indexOf('?') == -1){
                        setting.url += "?" + _contextForGET;
                    } else {
                        setting.url += "&" + _contextForGET;
                    }
                } else if(setting.type === 'POST'){
                    //$.extend(setting.data, _contextForPOST);
                    setting.data += "&" + _contextForGET;
                }
            } catch(ex) {
                debug.log(ex);
            }
        }
        */

		window.onhashchange = function () {
			Hades.loadFromHash();
		};

		$.datepicker.setDefaults($.datepicker.regional["pt"]);

		jQuery.fn.extend({
			disableSelection: function () {
				return this.each(function () {
					this.onselectstart = function () {
						return false;
					};
					this.unselectable = "on";
					jQuery(this).addClass("unselectable");
				});
			},
		});

		_appArea = _userAreaId;
		_state = Hades.STATE_FULL_SCREEN();

		// Show loading on every form submit event
		$(document).delegate("form[data-remote]", "submit", function (e) {
			if ($(this).attr("id") && $(this).attr("validation") != "false") {
				if (!GlobalFn.validateForm($(this).attr("id"), false, null, null)) {
					return false;
				}
			}

			Hades.showLoading();
		});

		$(document).delegate(
			"form[data-remote]",
			"ajax:error",
			function (e, data, status, error) {
				Hades.hideLoading();

				if (data.responseText.indexOf("413") != -1) {
					var error = data.responseText,
						title = "Tamanho do ficheiro inválido.",
						errorMsg =
							"Tamanho do ficheiro inválido. Máximo permitido é #MAX_VALUE#Mb.";
					errorMsg = errorMsg.replace("#MAX_VALUE#", _max_upload_size);

					error = error.replace("413 Request Entity Too Large", title);
					error = error.replace("413 Request Entity Too Large", errorMsg);

					$.fancybox({ content: error, title: title, titlePosition: "float" });
				} else {
					$.fancybox({
						content: data.responseText,
						title: Hades.genericErrorMsg(),
						titlePosition: "float",
					});
				}
			}
		);

		// Bind envents
		//$(window).bind('beforeunload', Hades.changePageProtection);

		$(document).on("click", ".k_tool_item", function (e) {
			$(this).addClass("active").siblings().removeClass("active");
			$(this)
				.parent()
				.trigger("change", { elem: $(this) });
		});

		$(document).on("click", ".push_btn", function (e) {
			var isActive = $(this).hasClass("active");

			$(this).toggleClass("active");

			if ($(this).data("target")) {
				$($(this).data("target")).trigger("buttonChangeStarted", {
					isOpen: isActive,
				});

				$($(this).data("target")).slideToggle("fast", function () {
					$(this).trigger("buttonChangeEnded", { isOpen: !isActive });
				});
			}
		});

		$(document).on("click", ".toggle_nav_bar li:not(active)", function (e) {
			$(this).addClass("active").siblings().removeClass("active");

			$(this)
				.parent()
				.trigger("buttonChanged", { id: $(this).attr("id") });
		});

		$("#app-language-bar").click(Hades.showLanguagePopup);

		$(document).on("click", ".toggle_slider", function (e) {
			var currValue = $(this).attr("data-value");
			var containerElement = $(this).find("[role=container]");
			var leftElement = $(this).find("[role=left]");
			var rightElement = $(this).find("[role=right]");

			var amount = null;
			var newValue = null;

			if ($(leftElement).attr("data-value") == currValue) {
				newValue = $(rightElement).attr("data-value");
				amount = "-73px";
			} else {
				newValue = $(leftElement).attr("data-value");
				amount = "-7px";
			}

			$(containerElement).animate({ marginLeft: amount }, 150, function () {
				// Animation complete.
				$(this).parent().attr("data-value", newValue);

				$("#" + $(this).parent().attr("data-target") + " option").each(() => {
					$(this).removeAttr("selected");
				});

				$("#" + $(this).parent().attr("data-target")).val(newValue);
				$("#" + $(this).parent().attr("data-target")).trigger("change");
			});
		});

		$(document).on("update", ".toggle_slider", function (e) {
			var currValue = $("#" + $(this).attr("data-target")).val();
			var containerElement = $(this).find("[role=container]");
			var leftElement = $(this).find("[role=left]");
			var rightElement = $(this).find("[role=right]");
			var amount = null;

			// Update selected value
			$(this).attr("data-value", currValue);

			if ($(leftElement).attr("data-value") == currValue) {
				amount = "-7px";
			} else {
				amount = "-73px";
			}

			$(containerElement).animate({ marginLeft: amount }, 150);
		});

		$(document).delegate("a[hades-screen]", "click", function (e) {
			if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
				Hades.hideLoading();
				return false;
			}

			_notifyScreenOnExit = false;

			e.preventDefault();

			var link = $(this),
				buttonId = link.attr("hades-button"),
				screen = link.attr("href"),
				screenType = link.attr("hades-screen"),
				state = link.attr("hades-state"),
				area = link.attr("hades-area"),
				params = link.attr("hades-params"),
				navId = link.attr("hades-nav");

			switch (screenType) {
				case "normal":
					Hades.showLoading();

					// Clear previous area
					clearContextualInfo(function () {
						_appArea = area;

						// Clear side nav
						$("#app-content-side-nav-buttons").empty();

						// Decode params
						var pl,
							p,
							_params = {};
						if (params != null) {
							pl = params.split(";");

							for (var i = 0; i < pl.length; i++) {
								p = pl[i].split(":");
								_params[p[0]] = p[1];
							}
						}

						// Check if this button has a screen defined, if not load sub-buttons
						if (screen != null && screen.length > 0) {
							changeAppState(Hades.STATE_FULL_SCREEN());

							// Clear navigation stack
							_navigationStack = [];

							Hades.clearShadowComponents();
							loadScreen(screen, _params, state, false);
						} else {
							changeAppState(state);
							// Load sub-buttons
							Hades.getSubButtons(area, buttonId, _params);
						}
					});

					break;

				case "modal":
					//loadModal(screen, params);
					break;

				case "help":
					Hades.showLoading();

					$.get("/help/index", { screen: _currScreen }, null, "html")
						.done(function (data, status, xhr) {
							Hades.checkIfUserIsAuthorized(data, status, xhr);

							$.fancybox({
								content: data,
								title: _help_msg,
								titlePosition: "float",
								autoDimensions: true,
								autoScale: true,
							});

							Hades.hideLoading();
						})
						.fail(function (xhr, status, error) {
							Hades.showError(error, xhr.responseText, xhr, status, error);
							Hades.hideLoading();
						});
					break;

				case "nav":
					Hades.showLoading();

					var pl = params.split(";"),
						p,
						_params = {};

					for (var i = 0; i < pl.length; i++) {
						p = pl[i].split(":");
						_params[p[0]] = p[1];
					}

					Hades.loadShortcut(navId, _params);
					break;
			}
		});

		$(document).delegate(".wf_icon", "mouseover", function (e) {
			_wfElem = $(this);

			if (
				!_wfElem.attr("title") &&
				_wfElem.attr("data-wf-id") &&
				_wfElem.attr("data-wf-status-id")
			) {
				_wfElemData = [
					_wfElem.attr("data-wf-id"),
					_wfElem.attr("data-wf-status-id"),
				].join("_");

				if (_wfStatus[_wfElemData] == null || _wfStatus[_wfElemData] == "") {
					if (_wfElemData != "_") {
						$.getJSON("/workflow/get_status_desc", {
							wf_id: _wfElem.attr("data-wf-id"),
							wf_status_id: _wfElem.attr("data-wf-status-id"),
						}).done(function (data, status, xhr) {
							var _wfKey = [data.wf_id, data.wf_status_id].join("_");

							if ("_" != _wfKey && _wfElemData == _wfKey) {
								_wfStatus[_wfKey] = data.wf_status_desc;
								_wfElem.attr("title", data.wf_status_desc);
							}
						});
					}
				} else {
					_wfElem.attr("title", _wfStatus[_wfElemData]);
				}
			} else {
				_wfElem.attr("title", "");
			}
		});

		$(document).delegate(".k_btn", "mousedown", function (e) {
			$(this).addClass("active");
		});

		$(document).delegate(".k_btn", "mouseup", function (e) {
			$(this).removeClass("active");
		});

		$(document).delegate(".k_btn", "mouseout", function (e) {
			$(this).removeClass("active");
		});

		$(document).delegate(".side_nav_btn_ct", "mouseover", function (e) {
			if (
				$(this).find(".side_nav_btn").hasClass("active") &&
				($("#contextual-buttons-container .default_add_button").length > 0 ||
					$("#screen-content-holder .default_add_button").length > 0)
			) {
				$(this).find(".default_add_button").show();
			}

			if (
				$(this).find(".side_nav_btn").hasClass("active") &&
				($("#contextual-buttons-container .default_edit_button").length > 0 ||
					$("#screen-content-holder .default_edit_button").length > 0)
			) {
				$(this).find(".default_edit_button").show();
			}
		});

		$(document).delegate(".side_nav_btn_ct", "mouseout", function (e) {
			$(this).find(".default_add_button").hide();
			$(this).find(".default_edit_button").hide();
		});

		$(document).delegate(
			".side_nav_btn_ct .default_add_button",
			"click",
			function (e) {
				if ($("#contextual-buttons-container .default_add_button").length > 0) {
					$("#contextual-buttons-container .default_add_button").click();
				} else if ($("#screen-content-holder .default_add_button").length > 0) {
					$("#screen-content-holder .default_add_button").click();
				}
			}
		);

		$(document).delegate(
			".side_nav_btn_ct .default_edit_button",
			"click",
			function (e) {
				if (
					$("#contextual-buttons-container .default_edit_button").length > 0
				) {
					$("#contextual-buttons-container .default_edit_button").click();
				} else if (
					$("#screen-content-holder .default_edit_button").length > 0
				) {
					$("#screen-content-holder .default_edit_button").click();
				}
			}
		);

		$("#app-content-ct").bind("screenLoaded", function (e) {
			if (
				$("#app-contextual-info").is(":visible") &&
				$("#contextual-nav-buttons").data("status") != "loaded"
			) {
				Hades.animateTopNav();
			}
		});

		$(document).delegate(
			".unit_picker a.unit_picker_item",
			"click",
			function (e) {
				var _p = $(this).closest(".unit_picker");
				_p.find("span.unit_lbl").html($(this).data("label"));
				_p.find("span.unit_lbl").attr("title", $(this).data("label"));
				_p.find("select.unit_id").val($(this).data("id"));
			}
		);

		$(document).delegate(".unit_picker select.unit_id", "change", function (e) {
			var _p = $(this).closest(".unit_picker");
			_p.find("span.unit_lbl").html($(this).find("option:selected").html());
			_p.find("span.unit_lbl").attr(
				"title",
				$(this).find("option:selected").html()
			);
		});

		$(document).delegate(".unit_picker select.unit_id", "reload", function (e) {
			var _p = $(this).closest(".unit_picker");
			var _l = _p.find("ul.dropdown-menu");
			var _options = $(this).find("option"),
				_opt;
			var _currOpt = $(this).val();

			// Remove old options
			_l.empty();

			// Add new options
			for (var i = 0; i < _options.length; i++) {
				_opt = $(_options[i]);
				_l.append(
					$(
						'<li><a class="unit_picker_item" data-id="' +
							_opt.attr("value") +
							'" data-label="' +
							_opt.html() +
							'" style="cursor: pointer;">' +
							_opt.html() +
							"</a></li>"
					)
				);
			}

			if (_currOpt === undefined || _currOpt == null || _currOpt == "") {
				_currOpt = $($(this).find("option").first()).attr("value");
				$(this).val(_currOpt).trigger("change");
			}

			$(this).val(_currOpt).trigger("change");
		});

		$(document).delegate("input.hasDatepicker", "blur", function (e) {
			$(this).css({
				"z-index": 1,
			});
		});

		$("#app-prof-alerts-ct").on("click", Hades.showProfAlerts);

		// Overlay events
		$("#overlay").click(function (e) {
			$(this).hide();
		});

		// Add key listeners
		$(window).keyup(function (e) {
			if (e.which == 27) {
				Popups.hideAll();
			}

			if ($("#overlay").hasClass("overlay_active")) {
				switch (e.which) {
					// ESC
					case 27:
						Hades.hideMetroMenu();
						break;
				}
			} else if ($("*:focus").length == 0) {
				switch (e.which) {
					// F1
					case 112:
						Hades.showMetroMenu();
						break;
				}
			}
		});

		// Add scroll handler
		$(window).scroll(function () {
			$("#app-header").removeClass("scroll_shadow");
			$("#contextual-nav").removeClass("scroll_shadow");

			if ($(window).scrollTop() > 0) {
				switch (parseInt(_state)) {
					case Hades.STATE_FULL_SCREEN():
					case Hades.STATE_SCREEN_W_SIDENAV():
						$("#app-header").addClass("scroll_shadow");
						break;

					case Hades.STATE_SCREEN_W_TOP_NAV():
					case Hades.STATE_SCREEN_W_NAV():
						$("#contextual-nav").addClass("scroll_shadow");
						break;
				}
			}
		});

		// Add resize handler
		$(window).bind("resize", function () {
			clearInterval(_resizeTimer);

			//_resizeTimer = setInterval(updateContentSize, 150);
			updateContentSize();

			// Reposition loading if visible
			if ($("#lock-ui").is(":visible")) {
				$("#lock-ui-loading-ct").css(
					"top",
					($(window).height() - 150) / 2 + "px"
				);
				$("#lock-ui-loading-ct").css(
					"left",
					($(window).width() - 150) / 2 + "px"
				);
			}
		});

		updateContentSize();

		// get version
		$.getJSON("/hades/get_version")
			.done(function (data, status, xhr) {
				//debug.log(data, status, xhr);
				if (xhr && xhr.status && xhr.status == 401) {
					//debug.log('Sign Out');

					// Redirect to login page
					window.location = "/users/sign_in";

					return false;
				}

				// Get Global Settings
				getGlobalSettings();

				// Load user info
				getUserHeader();

				// Load user nav
				getUserNav();

				if (data == null || data.length == 0) {
					//Hades.showError(Hades.noActionsTitle(), Hades.noActionsMsg(), xhr, status, null);
					return;
				}

				$("#software-version").html(
					"[" +
						data.code_name +
						"] " +
						data.major_version +
						"." +
						data.minor_version +
						"." +
						data.revision +
						"." +
						data.build
				);
				$("#software-version").attr(
					"title",
					data.code_name + " (" + data.install_date + ")"
				);
			})
			.fail(function (xhr, status, error) {
				if (xhr && xhr.status && xhr.status == 401) {
					// Redirect to login page
					window.location = "/users/sign_in";

					return false;
				}
			});
	};

	Hades.monthsShort = function () {
		return _monthsShort;
	};

	Hades.months = function () {
		return _months;
	};

	Hades.weekDays = function () {
		return _days;
	};

	Hades.currentDate = function () {
		return _date;
	};

	Hades.postRequest = function (url, params, callback) {
		$.post(url, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.success == false) {
					Hades.showError("Error", data);
				} else {
					if (callback != null) {
						//eval(callback);
						callback();
					}
				}

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.getWorkflowActions = function (
		taskId,
		wfId,
		wfStatusId,
		elem,
		actionsAlign,
		gridId,
		callback,
		params,
		hideCallback
	) {
		Hades.showLoading();

		$.getJSON("/workflow/get_actions", {
			wf_id: wfId,
			wf_status_id: wfStatusId,
			task_id: taskId,
		})
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				Hades.hideLoading();

				if (data == null || !data.success) {
					Hades.showError(Hades.workflowErrorMsg(), data.error);
					return;
				}

				var actions = data.result,
					other_info = data.other_info;
				debug.log("getWorkflowActions: ", data.result);

				// Convert list to multichoice
				for (var i = 0; i < actions.length; i++) {
					debug.log("action", actions[i]);
					actions[i].label = actions[i].desc_action;
					actions[i].data = actions[i].wf_action_id;
					actions[i].task_id = taskId;
					actions[i].grid_id = gridId;
					actions[i].params = params;
				}
				debug.log("elem", elem);
				if (actions.length > 0) {
					Popups.Multichoice.show(
						elem,
						actions,
						actionsAlign,
						callback == null ? onWfActionClick : callback,
						other_info,
						null,
						hideCallback
					);
					if (
						wfId == globalConstants.WF_DENTAL_MEDICINE_MEDICAL_ACT &&
						hideCallback
					) {
						hideCallback();
					}
				} else if (hideCallback) {
					hideCallback();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.getPatientActions = function (elem) {
		Hades.showLoading();

		$.getJSON("/workflow/get_patient_actions", null)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				Hades.hideLoading();

				if (data == null || !data.success || data.length == 0) {
					Hades.showError(Hades.workflowErrorMsg(), data.error);
					return;
				}

				if (data.result.length > 0) {
					Popups.Multichoice.show(
						elem,
						data.result,
						{ align: "left" },
						onPatientActionClick
					);
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.navigationStack = function () {
		return _navigationStack;
	};

	Hades.goToGrandFatherScreen = function (params) {
		if (_navigationStack.length > 1) {
			// pop twice to get parent of parent
			var nav1 = _navigationStack.pop();
			var nav = _navigationStack.pop();
			if (nav === undefined || nav == null || nav == "" || !nav.screen) {
				Hades.reloadCurrentSubButton();
				return true;
			}
			nav.params = $.extend(nav.params, params);
			// Load parent screen
			Hades.clearShadowComponents();
			loadScreen(nav.screen, nav.params, null, false);
		} else if (_navigationStack.length == 1) {
			// load previous screen
			Hades.goToPreviousScreen(params);
		} else if (_navigationStack.length == 0) {
			// load subButton menu
			Hades.reloadCurrentSubButton();
		}
		return true;
	};

	Hades.goToParentOfParamScreen = function (params, screen) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_goBackParams = params;
		_notifyScreenOnExit = false;

		if (_navigationStack.length == 0) {
			if (Hades.reloadCurrentSubButton()) {
				return true;
			}

			if (Hades.reloadCurrentTopButton()) {
				return true;
			}

			Hades.reloadScreen(params);
			return true;
		}

		var nav = _navigationStack.pop();

		if (nav === undefined || nav == null || nav == "" || !nav.screen) {
			return null;
		}

		if (nav.screen == screen) {
			// if the parent screen is dematerialized, it means that i'm in the materialized screen because i did not succeed due authorization
			debug.log("load parent: ", screen);
			Hades.goToPreviousScreen();
		} else {
			debug.log("load screen: ", screen);

			if (nav.areaId != _appArea) {
				_navigationStack.push(nav);

				return false;
			}

			if (params == null) {
				params = {};
			}

			nav.params = $.extend(nav.params, params);

			// Load previous screen
			Hades.clearShadowComponents();
			loadScreen(nav.screen, nav.params, null, false);

			_goBackParams = {};
		}
		return true;
	};
	Hades.goToPreviousScreen = function (params) {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_goBackParams = params;
		_notifyScreenOnExit = false;

		if (_navigationStack.length == 0) {
			if (Hades.reloadCurrentSubButton()) {
				return true;
			}

			if (Hades.reloadCurrentTopButton()) {
				return true;
			}

			Hades.reloadScreen(params);
			return true;
		}

		var nav = _navigationStack.pop();

		if (nav === undefined || nav == null || nav == "" || !nav.screen) {
			if (Hades.reloadCurrentSubButton()) {
				return true;
			}

			if (Hades.reloadCurrentTopButton()) {
				return true;
			}

			Hades.reloadScreen(params);
			return true;
		}

		if (nav.areaId != _appArea) {
			//changeAppState(nav.appState);
			//$('#user_nav_' + nav.topButtonId).addClass('active').siblings().removeClass('active');
			//Hades.loadArea(nav.areaId, nav.buttonId, nav.subButtonId, nav.params);

			_navigationStack.push(nav);

			return false;
		}

		if (params == null) {
			params = {};
		}

		nav.params = $.extend(nav.params, params);

		// Load previous screen
		Hades.clearShadowComponents();
		loadScreen(nav.screen, nav.params, null, false);

		_goBackParams = {};

		return true;
	};

	Hades.reloadCurrentSubButton = function () {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		if ($("#app-content-side-nav-buttons .active").length == 0) {
			return false;
		}

		$("#app-content-side-nav-buttons .active .side_nav_label").click();

		return true;
	};

	Hades.getSideNavDeeperLevel = function (parentId) {
		var parent = $("#subbutton_" + parentId);
		var l = $(parent).find(".side_children_nav_label");

		var childrenCt = $(parent.find(".side_nav_children"));

		if ($(l).hasClass("opened")) {
			$(l).removeClass("opened");
			$(childrenCt).slideUp();
		} else {
			$(l).addClass("opened");
			$(childrenCt).slideDown();
		}
	};

	Hades.playSound = function (sound) {
		if (sound == undefined || sound == null) {
			sound = "dooropen2.wav";
		}

		$("embed").remove();
		$("body").append(
			'<embed src="/sounds/' +
				sound +
				'" autostart="true" hidden="true" loop="false">'
		);
	};

	Hades.reloadCurrentTopButton = function () {
		if (_notifyScreenOnExit && !confirm(_help_save_msg)) {
			Hades.hideLoading();
			return false;
		}

		_notifyScreenOnExit = false;

		if ($("#app-user-nav-buttons .active").length == 0) {
			return false;
		}

		$("#app-user-nav-buttons .active").trigger("click");

		return true;
	};

	Hades.loadViewer = function (screen, params) {
		Hades.hideViewerLoading();

		$.get(screen, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$("#viewer-screen").empty();
				$("#viewer-screen").html(data).hide().fadeIn();

				Hades.hideViewerLoading();

				updateContentSize();
			})
			.fail(function (xhr, status, error) {
				// If user is not logged in redirect to sign in page
				if (xhr.status == 401) {
					window.location = "/users/sign_in";
					return;
				}

				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideViewerLoading();
			});
	};

	Hades.showViewerLoading = function () {
		$("#viewer-loading-ct").hide().fadeIn();
	};

	Hades.hideViewerLoading = function () {
		$("#viewer-loading-ct").hide();
	};

	Hades.unloadViewer = function () {
		$("#viewer-screen").empty();
	};

	Hades.getScreenViewerSync = function () {
		var app_button_id = null;
		var parent_app_button_id = null;

		$.getJSON("/viewer/config/screen_sync", {
			screen_path: _currScreen,
			/*app_button_id:app_button_id, parent_app_button_id:parent_app_button_id,*/ area_id:
				_appArea,
		})
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.length == 0) {
					return;
				}

				var config = data[0];
				if (config.viewer_action == "show") {
					var inParams = config.params.split(";"),
						params = {};

					for (var i = 0; i < inParams.length; i++) {
						params[inParams[i]] = $("#" + inParams[i]).val();
					}

					if (config.prof_category == '1') { /* DOCTOR */
						Hades.showViewer();
					}

					Hades.loadViewer(config.viewer_screen_path, params);
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.loadViewerScreen = function (screen, param) {
		var inParams = param.split(";"),
			params = {};

		for (var i = 0; i < inParams.length; i++) {
			params[inParams[i]] = $("#" + inParams[i]).val();
		}

		// Clear viewer
		$("#viewer-screen .viewer_content")
			.hide()
			.empty()
			.append(
				$(
					'<div style="width: 260px; background-color: #FFFFFF; height: 64px; margin: 4px;"><img style="margin: 8px;" src="/assets/progress_bar.gif" alt="Loading" align="middle"></div>'
				)
			)
			.show();

		$.get(screen, params, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$("#viewer-screen .viewer_content")
					.hide()
					.empty()
					.append(data)
					.fadeIn();
				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.reloadViewerScreen = function () {
		$(".viewer_buttons .v_btn.active").click();
	};

	Hades.openReport = function (
		format,
		reportName,
		params,
		callback,
		afterShow
	) {
		var p = { report_name: reportName, report_format: format };
		for (v in params) {
			p[v] = params[v];
		}

		$.getJSON("/reports/preview", p)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.success == true) {
					//if (data.report_format == "HTML") {
					var link = $(
						'<a class="various" data-fancybox-type="iframe" href="' +
							data.filename +
							'"></a>'
					);
					$(link)
						.fancybox({
							width: 800,
							height: 600,
							autoSize: false,
							afterClose: callback,
							afterShow: afterShow,
						})
						.click();
					//} else {
					//    window.open(data.filename);
					//}
				} else {
					Hades.showError("Error", Hades.genericErrorMsg(), xhr, status, data);
				}

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.workflowErrorMsg = function () {
		return _workflowErrorMsg;
	};

	Hades.genericErrorMsg = function () {
		return _genericErrorMsg;
	};

	Hades.okMsg = function () {
		return _ok_msg;
	};

	Hades.cancelMsg = function () {
		return _cancel_msg;
	};

	Hades.selectOptionsMsg = function () {
		return _select_options_msg;
	};

	Hades.selectOptionMsg = function () {
		return _select_option_msg;
	};

	Hades.noResultsMsg = function () {
		return _no_results_msg;
	};

	Hades.noActionsTitle = function () {
		return _noActionsTitle;
	};

	Hades.noActionsMsg = function () {
		return _noActionsMsg;
	};

	Hades.noAccessTitle = function () {
		return _noAccessTitle;
	};

	Hades.noAccessMsg = function () {
		return _noAccessMsg;
	};

	Hades.markAsReceivedWarning = function () {
		return _mark_as_received_warning;
	};

	Hades.markAsExecutedWarning = function () {
		return _mark_as_executed_warning;
	};

	Hades.delegateWarning = function () {
		return _delegate_warning;
	};

	Hades.checkIfUserIsAuthorized = function (data, status, xhr) {
		//debug.log(xhr.status);

		if (xhr && xhr.status && xhr.status == 401) {
			//$(window).unbind('beforeunload', Hades.changePageProtection);

			// Redirect to login page
			//window.location = '/';
			bootbox.alert(_session_expired_msg);
			$("#user_nav_15").click();

			return false;
		}

		return true;
	};

	Hades.changePageProtection = function (e) {
		return _leave_page_msg;
	};

	Hades.createPatient = function (params) {
		Hades.loadShortcut(34, params);
	};

	Hades.showBalloonMessage = function (message, type, delay) {
		$("#balloon-message").remove();

		var top;

		switch (parseInt(_state)) {
			case Hades.STATE_FULL_SCREEN():
				top = "105px";
				break;

			case Hades.STATE_SCREEN_W_TOP_NAV():
				top = "185px";
				break;

			case Hades.STATE_SCREEN_W_NAV():
				top = "185px";
				break;

			case Hades.STATE_SCREEN_W_SIDENAV():
				top = "105px";
				break;
		}

		var m = $(
			'<div id="balloon-message" class="bootstrap" style="position: fixed; top: ' +
				top +
				'; left: 50%; margin-left: -100px; width: 400px; text-align: center; padding: 5px;"></div>'
		);

		var ct = '<div class="control-group form-errors alert ' + type + '">';
		ct += '<a class="close" data-dismiss="alert">×</a>' + message;
		ct += "</div>";

		m.html(ct);

		$("body").append(m);

		var _delay = delay;
		if (_delay === undefined) {
			_delay = 2000;
		}

		if (_delay > 0) {
			setTimeout(Hades.clearBalloonMessage, _delay);
		}
	};

	Hades.clearBalloonMessage = function () {
		$("#balloon-message").fadeOut(1000, function () {
			$("#balloon-message").remove();
		});
	};

	Hades.loadFromHash = function () {
		var h = window.location.href.split("/#/?hades=");

		if (h.length != 2) {
			return;
		}

		if (h[1] == Hades.currentHash || !Hades.availableHash[h[1]]) {
			return;
		}

		var hash = h[1].split("|");

		if (hash.length != 6) {
			return;
		}

		// Decode params
		var paramsStr = $("#user_nav_" + hash[1])
				.parent()
				.attr("hades-params"),
			pl,
			p,
			_params = {};
		if (paramsStr != null) {
			pl = paramsStr.split(";");

			for (var i = 0; i < pl.length; i++) {
				p = pl[i].split(":");
				_params[p[0]] = p[1];
			}
		}

		if (Hades.paramHistory[h[1]]) {
			$.extend(_params, Hades.paramHistory[h[1]]);
		}

		// Unselect all top buttons
		$(".nav_button").removeClass("active");
		// Select top button id
		if ($("#user_nav_" + hash[1]).length > 0) {
			$("#user_nav_" + hash[1])
				.addClass("active")
				.siblings()
				.removeClass("active");
		}

		//debug.log('Area: ' + hash[0], 'User button: ' + hash[1], 'Top button: ' + hash[2], 'Sub button: ' + hash[3], 'Screen: ' + hash[4], _params, 'State: ' + hash[5]);

		Hades.setApplicationState(parseInt(hash[5]));

		Hades.loadArea(hash[0], hash[2], hash[3], _params, hash[4]);
	};

	Hades.showDocument = function (url) {
		var link = $(
			'<a class="various" data-fancybox-type="iframe" href="' + url + '"></a>'
		);
		$(link).fancybox({ width: 800, height: 600, autoSize: false }).click();

		Hades.hideLoading();
	};

	Hades.showTopNavMenu = function (elem) {
		var options = [],
			menus = $("#contextual-nav-buttons").find("li"),
			menu;

		for (var i = 0; i < menus.length; i++) {
			menu = $(menus[i]);
			options.push({
				label: menu.html(),
				tooltip: menu.html(),
				data: menu.attr("id"),
				params: {},
			});
		}

		Popups.Multichoice.show(
			elem,
			options,
			{ align: "right" },
			onTopNavActionClick
		);
	};

	Hades.setScreenCache = function (screen, value) {
		_cache[screen] = value;
	};

	Hades.getScreenCache = function (screen) {
		return _cache[screen];
	};

	Hades.getPatientWarnings = function (patientId, elem) {
		$.getJSON("/patients/patient_warnings", { patient_id: patientId })
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$(elem).empty();

				try {
					switch (parseInt(data.semaphore)) {
						case 1:
							$(elem).append(
								$(
									'<div style="margin-left: 2px; margin-top: 10px;" title="' +
										data.tooltip +
										'" class="circle_12x12 red_circle"></div>'
								)
							);
							break;
						case 2:
							$(elem).append(
								$(
									'<div style="margin-left: 2px; margin-top: 10px;" title="' +
										data.tooltip +
										'" class="circle_12x12 orange_circle"></div>'
								)
							);
							break;
						case 3:
							$(elem).append(
								$(
									'<div style="margin-left: 2px; margin-top: 10px;" title="' +
										data.tooltip +
										'" class="circle_12x12 green_circle"></div>'
								)
							);
							break;
						default:
							$(elem).append(
								$(
									'<div style="margin-left: 2px; margin-top: 10px;" class="circle_12x12 gray_circle"></div>'
								)
							);
							break;
					}
				} catch (ex) {
					$(elem).append(
						$(
							'<div style="margin-left: 2px; margin-top: 10px;" class="circle_12x12 gray_circle"></div>'
						)
					);
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.getMaxUploadSize = function () {
		return _max_upload_size;
	};

	Hades.getUploadSizeErrorTitle = function () {
		return _upload_size_error_title;
	};

	Hades.getUploadSizeError = function () {
		return _upload_size_error;
	};

	Hades.getUploadSizeFormError = function () {
		return _upload_size_form_error;
	};

	Hades.setCurrentScreen = function (screen) {
		_currScreen = screen;

		return true;
	};

	Hades.scrollContainer = function (container, direction, step) {
		if (Hades.isTouch()) {
			return;
		}

		var _widths,
			_totalWidth = 0,
			index;

		_widths = $("#contextual-nav-buttons li").map(function () {
			return $(this).width() + 20;
		});

		index = _widths.length;

		while (index--) {
			_totalWidth += _widths[index];
		}

		$("#contextual-nav-buttons").css("width", _totalWidth + 64);

		step = step ? step : 30;

		var _left, _step, _final;

		try {
			_step = parseInt(step);
		} catch (ex) {
			_step = 30;
		}
		_step = _step * direction;

		try {
			_left = parseInt(
				$("#contextual-nav-buttons").css("left").replace("px", "")
			);
		} catch (ex) {
			_left = 0;
		}

		// calculate final position
		_final = _left + _step;

		if (direction == 1) {
			_final = Math.min(_final, 0);
		} else {
			_final = Math.max(
				_final,
				-1 *
					Math.max(
						$(container).width() - $("#contextual-nav-buttons-mask").width(),
						0
					)
			);
		}

		// Check for same position
		if (_final == _left) {
			return;
		}

		$(container).animate({ left: _final }, 100, "linear", function () {
			if ($(container).hasClass("scroll")) {
				Hades.scrollContainer(container, direction, step);
			}
		});
	};

	Hades.animateTopNav = function (effect) {
		var _widths,
			_totalWidth = 0,
			index,
			_effect = effect || "easeOutCubic";

		_widths = $("#contextual-nav-buttons li").map(function () {
			return $(this).width() + 20;
		});

		index = _widths.length;

		while (index--) {
			_totalWidth += _widths[index];
		}

		$("#contextual-nav-buttons")
			.css("top", 0)
			.data("status", "loaded")
			.css("left", -1 * (_totalWidth - 64))
			.show();

		$("#contextual-nav-buttons")
			.css("width", _totalWidth + 64)
			.css("left", -1 * _totalWidth)
			.animate(
				{ left: 0 },
				1000,
				_effect /*, function(){
                // Ensure that active button is visible
                if($('#contextual-nav-buttons li.active').position().left < $('#contextual-nav-buttons').position().left){
                    $('#contextual-nav-buttons-mask').animate({scrollLeft:'-'+$('#contextual-nav-buttons li.active').position().left+'px'});
                } else if($('#contextual-nav-buttons li.active').position().left+$('#contextual-nav-buttons li.active').width() > $('#contextual-nav-buttons-mask').width()){
                    $('#contextual-nav-buttons-mask').animate({scrollLeft:'-'+($('#contextual-nav-buttons li.active').position().left-$('#contextual-nav-buttons li.active').width())+'px'});
                }
            }*/
			);
	};

	Hades.scrollUserNav = function (container, direction, step) {
		if (Hades.isTouch()) {
			return;
		}

		step = step ? step : 70;

		var _left, _step, _final, _m;

		try {
			_step = parseInt(step);
		} catch (ex) {
			_step = 70;
		}
		_step = _step * direction;

		try {
			_left = parseInt($(container).css("left").replace("px", ""));
		} catch (ex) {
			_left = 0;
		}

		// calculate final position
		_final = _left + _step;

		if (direction == 1) {
			_final = Math.min(_final, 0);
		} else {
			_m = parseInt($("#app-user-nav-buttons").data("mwidth"));

			if (
				_m <
				$("#app-user-nav-scroll-right").position().left -
					$("#app-user-nav-scroll-left").position().left -
					70
			) {
				return;
			}

			_final = Math.max(
				_final,
				-1 *
					(_m -
						($("#app-user-nav-scroll-right").position().left -
							$("#app-user-nav-scroll-left").position().left) +
						70)
			);
		}

		// Check for same position
		if (_final == _left) {
			return;
		}

		$(container).animate({ left: _final }, 100, "linear", function () {
			if ($(container).hasClass("scroll")) {
				Hades.scrollUserNav(container, direction, step);
			}
		});
	};

	Hades.isTouch = function () {
		return _isTouch;
	};

	Hades.refreshLayout = function () {
		updateContentSize();
	};

	Hades.createContextualButtons = function (container, clone) {
		$("#contextual-buttons-container").hide().empty();

		var ct;

		if (clone == true) {
			ct = $(container).clone();
		} else {
			ct = $(container);
		}

		if ($(ct).children().length == 0) {
			return;
		}

		$(ct)
			.removeClass("contextual_buttons")
			.addClass("inner_ct")
			.appendTo($("#contextual-buttons-container"));

		Hades.changeContextualButtonsBarOrientation();

		$("#contextual-buttons-container").show();

		Hades.showContextualButtons();
	};

	Hades.showContextualButtons = function () {
		$("#contextual-buttons").show();
		$("#contextual-buttons-mirror").show();

		updateContentSize();
	};

	Hades.hideContextualButtons = function () {
		$("#contextual-buttons").hide();
		$("#contextual-buttons-mirror").hide();

		updateContentSize();
	};

	Hades.clearContextualButtons = function () {
		$("#contextual-buttons-container").empty();

		$("#contextual-buttons").hide();
		$("#contextual-buttons-mirror").hide();

		updateContentSize();
	};

	Hades.changeContextualButtonsBarOrientation = function (orientation) {
		if (orientation) {
			_contextualBarOrientation = orientation;
		}

		if (_contextualBarOrientation == "buttons_on_center") {
			var buttonCount = $("#contextual-buttons-container").find(
				"button"
			).length;
			var spacerCount = $("#contextual-buttons-container").find(
				"img.button_spacer"
			).length;
			var _width = buttonCount * 36 + (buttonCount - 1) * 4;
			_width += spacerCount * 10;

			$("#contextual-buttons-container .inner_ct").css("width", _width + "px");
		} else {
			$("#contextual-buttons-container  .inner_ct").css("width", "auto");
		}

		$("#contextual-buttons-container")
			.removeClass("buttons_on_left")
			.removeClass("buttons_on_center")
			.removeClass("buttons_on_right")
			.addClass(_contextualBarOrientation);
	};

	Hades.notifyScreenOnExit = function (notify) {
		if (notify) {
			_notifyScreenOnExit = notify;
		} else {
			_notifyScreenOnExit = false;
		}

		return this;
	};

	Hades.locale = function () {
		return _locale;
	};

	Hades.addScreenRef = function (screen) {
		if (screen) {
			if (screen instanceof Array) {
				_screenRef = _screenRef.concat(screen);
			} else {
				_screenRef.push(screen);
			}
		}
	};

	Hades.showProfAlerts = function () {
		Hades.showLoading();

		$.get("/professional/professional_alerts_modal", null, null, "html")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				$.fancybox({
					content: data,
					autoScale: true,
					autoDimensions: true,
					afterClose: Hades.getUserAlerts,
				});

				Hades.hideLoading();
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.getPatientActionReport = function (action) {
		onPatientActionClick(action);
	};

	Hades.convertTimeToCalendarSlotDate = function (date) {
		var event_start_time = date
			.toTimeString()
			.split(" ")[0]
			.substring(0, 5)
			.replace(":", "_");

		debug.log("event_start_time", event_start_time);

		var array_date = event_start_time.split("_");
		var final_date_hour = "";
		var final_date_minutes = "";

		$.each(array_date, function (index, value) {
			if (index == 1) {
				final_date_hour = value.replace(/^0+/, "");
			} else {
				final_date_minutes = value.replace(/^0+/, "");
			}
		});

		var final_date = final_date_hour + "_" + final_date_minutes;

		return final_date;
	};

	Hades.convertTimeSlotDateToTime = function (i_hour) {
		var minutes = "";
		var hour = "";

		var array_time = i_hour.split("_");

		//hour = array_time[0];

		if (array_time[1].length == 1) {
			minutes = "0" + array_time[1];
		} else {
			minutes = array_time[1];
		}

		if (array_time[0].length == 1) {
			hour = "0" + array_time[0];
		} else {
			hour = array_time[0];
		}

		return hour + ":" + minutes;
	};

	Hades.rescheduleValidateSlots = function (
		event,
		element,
		view,
		allEventsSize,
		callback
	) {
		var check = [];
		var array_data_date = [];
		//get event hour
		var event_start = event.start;
		var event_end = event.end;

		var month = event.start.getUTCMonth(); //months from 1-12
		var day = event.start.getUTCDate();
		var year = event.start.getUTCFullYear();

		var input = $('input[name="professional_filter_rb"]:checked');

		debug.log("input", input);

		$(input)
			.closest("td")
			.find('.fc-widget-content[data-date!=undefined][data-date!="0_0"]')
			.each(function (index, elem) {
				if ($(elem).data("date") !== undefined) {
					var time_temp = Hades.convertTimeSlotDateToTime($(elem).data("date"));

					var date = new Date(
						year,
						month,
						day,
						parseInt(time_temp.substring(0, 2)),
						parseInt(time_temp.substring(3, 5))
					);

					var slot = {
						workable: $(elem).data("workable"),
						date: date,
					};

					if (date >= event_start && date < event_end) {
						//array_data_date.push(slot);

						if (slot.workable == "f") {
							check.push(true);
						} else {
							check.push(false);
						}
					}
				}
			});

		var params = {
			event: event, //event
			check: check, //all slots check to event
		};

		if ((calendar_dayView.reload_after_picker_date_from_reschedule = "true")) {
			debug.log("onRescheduledCalendarLoaded params", params);

			$("#calendar-outer").trigger("onRescheduledCalendarLoaded", params);
		}

		callback(event, element, view);

		return array_data_date;
	};

	Hades.executeWorkflowfActionParams = function (action, callback) {
		debug.log("actionww", action);

		if (action.wf_action_params) {
			var result = $.parseJSON(action.wf_action_params);

			$.each(result, function (i, item) {
				if (
					item.flg_enable &&
					item.action_type == globalConstants.WF_ACTION_TYPE_LOAD_SHORTCUT
				) {
					action.institutions_id = item.institutions_id;
					action.softwares_id = item.softwares_id;

					$.get("/shortcut/get_shortcut_configuration", action, null, "json")
						.done(function (data) {
							debug.log("result data", data);
							if (data) {
								Hades.loadShortcut(data, {
									id: action.params.task_id,
									wf_id: action.params.wf_id,
									type: "episode",
								});
							} else {
								debug.log("entrei else callback - no sh_id returned");
								callback();
							}

							Hades.hideLoading();
						})
						.fail(function (xhr, status, error) {
							Hades.showError(error, xhr.responseText, xhr, status, error);
							Hades.hideLoading();
						});
				}
				if (item.flg_enable && item.action_type == "load_modal") {
					action.institutions_id = item.institutions_id;
					action.softwares_id = item.softwares_id;
				}
			});
		} else {
			callback();
		}
	};

	Hades.saveScreen = function (screenContainer, url, callback) {
		var obj = {};
		var paramsList = [];

		var elementList = $("#" + screenContainer + ' [data-param-save="true"]');
		var elementMultipleList = $(
			"#" + screenContainer + " select[multiple=multiple]"
		);

		for (var i = 0; i < elementList.length; i++) {
			field = $(elementList[i]);

			var obj_field = field.data();

			switch (field.attr("type")) {
				case "radio":
					if (field.attr("checked")) {
						obj_field.value = $(elementList[i]).val();
						paramsList.push(obj_field);
					}
					break;

				case "text":
					obj_field.value = $(elementList[i]).val();
					obj_field.datepicker = undefined;
					paramsList.push(obj_field);
					break;

				case "number":
					obj_field.value = $(elementList[i]).val();
					paramsList.push(obj_field);
					break;

				case "hidden":
					obj_field.value = $(elementList[i]).val();
					paramsList.push(obj_field);
					break;

				case "option":
					if (field.attr("selected")) {
						obj_field.value = $(elementList[i]).val();
						paramsList.push(obj_field);
					}
					break;
				case "input":
					obj_field.value = $(elementList[i]).val();
					paramsList.push(obj_field);
					break;

				default:
					if ($(field).is(":selected")) {
						obj_field.value = $(elementList[i]).val();
						paramsList.push(obj_field);
					}
			}
		}

		for (var i = 0; i < elementMultipleList.length; i++) {
			field = $(elementMultipleList[i]);
			paramsList.push({
				paramSave: true,
				paramName: field.data("param-name"),
				value: $(elementMultipleList[i]).val(),
			});
		}

		obj.params = JSON.stringify(paramsList);

		$.post(url, obj, null, "json")
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				if (data.result == true) {
					if (
						$("#" + screenContainer + " #attachments-container").length > 0 &&
						$(
							"#" + screenContainer + " #attachments-container"
						).FileUploadHelper("getDocuments").length > 0
					) {
						$(
							"#" + screenContainer + " #attachments-container"
						).FileUploadHelper("uploadAttachs", data.data, callback);
					} else {
						if (callback) {
							callback();
						} else {
							Hades.hideLoading();
						}
					}
				} else {
					Hades.hideLoading();
				}
			})
			.fail(function (xhr, status, error) {
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.get_wf_status = function () {
		$.getJSON("/hades/get_wf_status", null)
			.done(function (data, status, xhr) {
				Hades.checkIfUserIsAuthorized(data, status, xhr);

				return data;
			})
			.fail(function (xhr, status, error) {
				return null;
				Hades.showError(error, xhr.responseText, xhr, status, error);
				Hades.hideLoading();
			});
	};

	Hades.toggleFullScreen = function (elem) {
		if (elem.requestFullscreen) {
			elem.requestFullscreen();
		} else if (elem.webkitRequestFullscreen) {
			/* Safari */
			elem.webkitRequestFullscreen();
		} else if (elem.msRequestFullscreen) {
			/* IE11 */
			elem.msRequestFullscreen();
		}
	};

	Hades.clearKentraSidebarEventsListeners = function () {
		$("#dlms-fe").attr("force-destroy", true);
		$("#kml-fe").attr("force-destroy", true);
		$("#ksp-fe").attr("force-destroy", true);
		window.removeEventListener('ksShortcutClick', Hades.ksShortcutClick);
		window.removeEventListener('ksStateClick', Hades.ksStateClick);
		window.removeEventListener('ksLoadMoreEpisodes', Hades.ksLoadMoreEpisodes);
        window.removeEventListener('ksCreatePrescriptionClick', Hades.ksCreatePrescriptionClick);
        window.removeEventListener('ksCreateExamRequisition', Hades.ksCreateExamRequisition);
        window.removeEventListener('ksCreateDiagnostics', Hades.ksCreateDiagnostics);
	};

	Hades.clearShadowComponents = function () {
		$("#dlms-fe").attr("force-destroy", true);
		$("#ksp-fe").attr("force-destroy", true);
		$("#kml-fe").attr("force-destroy", true);
	};

	window.Hades = Hades;
})(jQuery);
